import React, { Component, useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LockIcon from '@mui/icons-material/Lock';
import Check from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
// import DriveFileMoveOutlineIcon from '@mui/icons-material/DriveFileMoveOutline';
import DriveFileMoveRtlIcon from '@mui/icons-material/DriveFileMoveRtl';

import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import 'primereact/resources/themes/lara-light-blue/theme.css';
import './document.css'

import SplitPane, { Pane } from 'split-pane-react-uxrd';
import 'split-pane-react-uxrd/esm/themes/default.css';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { EffectivityChooser } from "../effectivity/effectivity-chooser";
import { RevisionRecordConfig } from "./management-revision-record";

import { ColorPickerDialog  } from "../util/color";



import { UserInfo, netGet, netPost, netFetch, keycloak } from "../network";

// import { setOpenNextStep } from "features/menu/menuSlice";


const DOCUMENT_TYPES = [
    'None',
    'AIRBUS',
    'BOEING',
    'JET',
    'PROP',
    '777',
    '787',
    'A320',
    'ATR',
    'Q300',
    'Other',
];

const SHORT_NAMES = [
    'CCGOP',
    'DDG',
    'FCOM',
    'QRH',
    'SOP',
    'Other',
];

const DEFAULT_SCHEMAS = [
    {id: 'QRH', name: 'QRH'},
    {id: 'OMA', name: 'OMA'},
    {id: 'PAM', name: 'Passenger Announcements'},
    {id: 'FCOM', name: 'FCOM'},
    {id: 'SUPP', name: 'Supplements'}

];

const DEFAULT_STYLES = [
    {name: 'A4 Standard', path: '/'},
    {name: 'A5 FCOM', path: '/'},
    {name: 'A5 Route Guide', path: '/'},
    {name: 'A5 QRH', path: '/'},
];

function CreateDocumentGeneralDialog(props) {
    const {
        title = 'Create Document—General Information',
        instance = null,
        documentList,
        open,
        onSave,
        onCancel,
        initial=false, // whether this is the initial create document dialog outside of workflow
        ...other
    } = props;

    const [nameValue, setNameValue] = useState('');
    const [shortNameValue, setShortNameValue] = useState('');
    const [descriptionValue, setDescriptionValue] = useState('');
    const [typeValue, setTypeValue] = useState('None');
    const [otherValue, setOtherValue] = useState('');
    const [otherShortValue, setOtherShortValue] = useState('');
    const [idValue, setIdValue] = useState('');
    const [config, setConfig] = useState(null); // DLib config id (Long)
    const [docNameList, setDocNameList] = useState([]);
    const [schemaValue, setSchemaValue] = useState('');
    const [schemaList, setSchemaList] = useState([]);
    const [operator, setOperator] = useState('');
    const [okEnabled, setOkEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };

    const DocMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                minWidth: 300,
            },
        },
    };

    useEffect( () => {
        netGet('/config/realm')
            .then(response => response.json())
            .then(rinfo => {
                if ( rinfo?.realm ) {
                    setOperator(rinfo.realm);
                }
            }).catch ( error => {
                console.log('Error fetching realm name: ' + error);
            });
    },[]);

    useEffect( () => {
        if ( open && instance ) {
            setNameValue(instance.properties?.instanceName);
            if ( instance.properties?.docDescription) {
                setDescriptionValue(instance.properties.docDescription);
            } else {
                setDescriptionValue('');
            }
            if ( instance.properties?.document) {
                setIdValue(instance.properties.document);
            } else {
                setIdValue('');
            }
            setErrorMessage('');
            loadInstanceConfiguration(instance);
        } else {
            setNameValue('');
            setIdValue('');
            setShortNameValue('');
            setDescriptionValue('');
            setTypeValue('None');
            setOtherValue('');
            setOtherShortValue('');
            setConfig(null);
            setErrorMessage('Please set required fields');
            setOkEnabled(false);
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'GEN', openWorkflowId: instance?.id}));
        // }

    },[open, instance]);

    const loadInstanceConfiguration = (inst) => {
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.properties?.document) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config);
                    const m = config.properties?.general?.model ? config.properties.general.model : '';
                    setTypeValue(m);
                    const om = config.properties?.general?.otherModel ? config.properties.general.otherModel : '';
                    setOtherValue(om);
                    const s = config.properties?.general?.shortName ? config.properties.general.shortName : '';
                    setShortNameValue(s);
                    const os = config.properties?.general?.otherShortName ? config.properties.general.otherShortName : '';
                    setOtherShortValue(os);
                    if ( config.description ) {
                        setDescriptionValue(config.description);
                    }
                    let n = config.properties?.general?.displayName ? config.properties?.general?.displayName : inst.properties?.instanceName;
                    if ( !n ) {
                        n = '';
                    }
                    computeOkEnable(inst.properties?.document, n, m, om, s, os);
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = (docid, name, model, otherModel, shortName, otherShortName ) => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        let value = true;
        if ( docid !== instance?.properties?.document ) {
            if ( Array.isArray(docNameList) ) {
                const di = docNameList.find( d => d === docid);
                if ( di && di !== instance?.properties?.document ) {
                    value = false;
                    console.log('Found duplicate doc id = ' + di + ' DOCS: ' + JSON.stringify(docNameList));
                    setErrorMessage('Identifier already in use')
                }
            }
        }
        if ( !name || name.trim() === '') {
            value = false;
            console.log('Name is not valid');
            setErrorMessage('Please set required fields');
        }
        if ( !model || model.trim() === '') {
            value = false;
            console.log('Type is not valid');
        } else if ( model === 'Other' ) {
            if (!otherModel || otherModel.trim() === '') {
                value = false;
                console.log('Other type is not valid');
                setErrorMessage('Please set required fields');
            }
        }
        if ( !shortName || shortName.trim() === '') {
            value = false;
            console.log('shortName is not valid');
            setErrorMessage('Please set required fields');
        } else if ( shortName === 'Other' ) {
            if ( !otherShortName || otherShortName.trim() === '') {
                value = false;
                console.log('Other shortName is not valid');
                setErrorMessage('Please set required fields');
            }
        }
        if ( value ) {
            setErrorMessage('');
        }
        // console.log('OK enabled = ' + value);
        setOkEnabled(value);
    };


    React.useEffect( () => {
        if (Array.isArray(documentList)) {
            const dl = documentList.map( d => d.id);
            setDocNameList(dl);
        } else {
            setDocNameList([]);
            netGet('/api/doc/roots?sort=alpha')
                .then(response => response.json())
                .then(docs => {
                    if (Array.isArray(docs)) {
                        netGet('/api/workflow/inst/find/bystate/MGT_DOC')
                            .then(resp => resp.json())
                            .then(insts => {
                                // console.log('Got create workflow documents: ' + JSON.stringify(insts));
                                if (Array.isArray(insts)) {
                                    const dinsts = insts.map(wi => {
                                        return {
                                            id: wi.properties?.document,
                                            document: wi.properties?.document,
                                            title: wi.properties?.instanceName,
                                            workflowInstance: wi,
                                            docType: 'MGT_DOC', // as oppose to DDIS

                                        };
                                    });
                                    const dss = [...docs, ...dinsts];
                                    dss.sort((a, b) => a.title.localeCompare(b.title));
                                    // console.log('ALL documents: ' + JSON.stringify(dss));
                                    // const q = dss.find( d => d.id === 'NZ_QRH');
                                    // console.log("QRH DOC: " + JSON.stringify(q));
                                    const dl = dss.map(d => d.id);
                                    setDocNameList(dl);
                                }
                            }).catch(err => {
                                console.log('Error fetching management create document workflows: ' + err);
                            });
                    }
                }).catch(error => {
                    console.log('Error fetching profiles: ' + error);
                });
        }
    },[documentList]);

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = {
                configId: config ? config.id : null,
                name: nameValue,
                description: descriptionValue,
                type: typeValue,
                shortName: shortNameValue,
                id: idValue,
                otherProps: config ? config.properties : null,
            };
            if ( typeValue === 'Other') {
                vv['other'] = otherValue;
            }
            if ( shortNameValue === 'Other' ) {
                vv['otherShortName'] = otherShortValue;
            }
            onSave(vv, action);
        }
    }

    const onNextClick = () => {
        onOKClick('NEXT');
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const nameChanged = (event) => {
        setNameValue(event.target.value);
        computeOkEnable(idValue, event.target.value, typeValue, otherValue, shortNameValue, otherShortValue);
    };

    const descriptionChanged = (event) => {
        setDescriptionValue(event.target.value);
    };

    const handleTypeChange = (event) => {
        setTypeValue(event.target.value);
        computeIdValue(event.target.value, otherValue, shortNameValue, otherShortValue);
        computeOkEnable(idValue, nameValue, event.target.value, otherValue, shortNameValue, otherShortValue);
    };

    const otherChanged = (event) => {
        setOtherValue(event.target.value);
        computeIdValue(typeValue, event.target.value, shortNameValue, otherShortValue);
    };

    const handleShortNameChange = (event) => {
        setShortNameValue(event.target.value);
        const id = computeIdValue(typeValue, otherValue, event.target.value, otherShortValue);
        computeOkEnable(id, nameValue, typeValue, otherValue, event.target.value, otherShortValue);
    };

    const otherShortChanged = (event) => {
        setOtherShortValue(event.target.value);
        const id = computeIdValue(typeValue, otherValue, shortNameValue, event.target.value);
        computeOkEnable(id, nameValue, typeValue, otherValue, shortNameValue, event.target.value);
    };

    const idValueChanged = (event) => {
        setIdValue(event.target.value);
        computeOkEnable(event.target.value, nameValue, typeValue, otherValue, shortNameValue, otherShortValue);
    };

    const computeIdValue = (t, to, s, so) => {
        const tt = t === 'Other' ? to : t;
        const tti = tt.trim() === '' || tt.trim() === 'None' ? '' : `_${tt}`;
        const ss = s === 'Other' ? so : s;
        let id = `${operator}${tti}_${ss}`;
        // check is not already used
        if ( id !== instance?.properties?.document ) { // this one is ok
            if ( Array.isArray(docNameList) ) {
                let di = docNameList.find( d => d === id);
                let i = 1;
                let nid = id;
                while ( di && i < 40) {
                    if ( i < 10 ) {
                        nid = `${id}_0${i}`;
                    } else {
                        nid = `${id}_${i}`;
                    }
                    di = docNameList.find( d => d === nid);
                    i++;
                }
                id = nid;
            }
        }
        setIdValue(id);
        return id;
    };

    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { 
                    sx: {
                        minWidth: 800,
                        maxHeight: 700
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                { !initial && 
                  <Box sx={{display: 'flex', paddingTop: '2ex', justifyContent: 'flex-end', alignItems: 'center' }}>
                     <Button variant="outlined" onClick={onNextClick} sx={{minWidth: '8em'}} disabled={!okEnabled} endIcon={<ArrowForwardIosIcon/>}>Next</Button>
                  </Box>
                }
                <Box sx={{ paddingTop: '2em' }}>
                    <TextField label="Name *" value={nameValue} onChange={nameChanged} size="small" fullWidth
                        helperText="Display name"
                        />
                </Box>
                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Description" value={descriptionValue} onChange={descriptionChanged} size="small"
                        multiline fullWidth
                        rows={3} />
                </Box>

                <Box sx={{paddingTop: 1}}>
 
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '7em', minWidth: '7.5em' }}>Type *:</Typography>
                        <FormControl sx={{ m: 1, minWidth: 120, marginLeft: 0 }} size="small">
                            <Select
                                value={typeValue}
                                onChange={handleTypeChange}
                                sx={{ minWidth: '160px' }}
                                MenuProps={TypeMenuProps}
                            >
                                {DOCUMENT_TYPES.map(dt =>
                                    <MenuItem key={`DT-${dt}`}
                                        value={dt}>
                                        {dt}
                                    </MenuItem>
                                )}
                                
                            </Select>
                        </FormControl>
                        {typeValue === 'Other' &&
                            <TextField label="Type" value={otherValue} onChange={otherChanged} size="small" fullWidth sx={{marginLeft: 8}}/>
                        }
                    </Box>
                    <Typography sx={{ fontSize: '80%', color: 'gray' }}>Aircraft type or model</Typography>
                </Box>
                <Box sx={{paddingTop: 2}}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '7.5em', minWidth: '7em' }}>Short Name *:</Typography>
                        <FormControl sx={{ m: 1, minWidth: 120, marginLeft: 0 }} size="small">
                            <Select
                                value={shortNameValue}
                                onChange={handleShortNameChange}
                                sx={{ minWidth: '160px' }}
                                MenuProps={TypeMenuProps}
                            >
                                {SHORT_NAMES.map(dt =>
                                    <MenuItem key={`DT-${dt}`}
                                        value={dt}>
                                        {dt}
                                    </MenuItem>
                                )}
                                
                            </Select>
                        </FormControl>
                        {shortNameValue === 'Other' &&
                            <TextField label="Short Name" value={otherShortValue} onChange={otherShortChanged} size="small" fullWidth sx={{marginLeft: 8}}/>
                        }
                    </Box>
                    <Typography sx={{ fontSize: '80%', color: 'gray' }}>Document short name or abbreviation</Typography>
                </Box>
                <Box sx={{paddingTop: 3}}>
                    <TextField label="Identifier *" value={idValue} onChange={idValueChanged} size="small" fullWidth />
                </Box>

                {/* !editOnly &&
                    <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '5.5em' }}>Template:</Typography>
                        {Array.isArray(template) ?

                            <FormControl sx={{ m: 1, minWidth: '350px', width: '400px' }} size="small">
                                <Select
                                    value={templateValue}
                                    onChange={handleTemplateChange}
                                    sx={{ minWidth: '350px', width: '400px' }}
                                    MenuProps={CreateMenuProps}
                                >
                                    {template.map((templateName) => (
                                        <MenuItem
                                            key={'cswd' + templateName}
                                            value={templateName}
                                        >
                                            {templateName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            :

                            <Typography sx={{ paddingLeft: '1em' }}>{template}</Typography>
                        }
                    </Box>
                */}
            </DialogContent>
            <DialogActions sx={{padding: 3, display: 'flex', justifyContent: 'space-between'}}>
                <Typography color="warning">{errorMessage}</Typography>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );

}

function CreateDocumentGeneralPanel(props) {
    const {
        title = 'Create Document—General Information',
        documentList,
        onChange,
        ...other
    } = props;

    const [nameValue, setNameValue] = useState('');
    const [shortNameValue, setShortNameValue] = useState('');
    const [descriptionValue, setDescriptionValue] = useState('');
    const [typeValue, setTypeValue] = useState('None');
    const [otherValue, setOtherValue] = useState('');
    const [otherShortValue, setOtherShortValue] = useState('');
    const [idValue, setIdValue] = useState('');
    const [config, setConfig] = useState(null); // DLib config id (Long)
    const [docNameList, setDocNameList] = useState([]);
    const [operator, setOperator] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const document = useSelector((state) => state.documentConfig.general);
    // const dispatch = useDispatch();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };

    const DocMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                minWidth: 300,
            },
        },
    };

    useEffect( () => {
        netGet('/config/realm')
            .then(response => response.json())
            .then(rinfo => {
                if ( rinfo?.realm ) {
                    setOperator(rinfo.realm);
                }
            }).catch ( error => {
                console.log('Error fetching realm name: ' + error);
            });
    },[]);

    useEffect( () => {
        if ( document ) {
            if ( document.name ) {
                setNameValue(document.name);
            } else {
                setNameValue('');
            }
            if ( document.description ) {
                setDescriptionValue(document.description);
            } else {
                setDescriptionValue('');
            }
            if ( document.type ) {
                if (DOCUMENT_TYPES.includes(document.type) ) {
                    setTypeValue(document.type);
                    setOtherValue('');
                } else {
                    setTypeValue('Other');
                    setOtherValue(document.type);
                }
            } else {
                setTypeValue('None');
                setOtherValue('');
            }
            if ( document.shortName ) {
                if ( SHORT_NAMES.includes(document.shortName) ) {
                    setShortNameValue(document.shortName);
                    setOtherShortValue('');
                } else {
                    setShortNameValue('Other');
                    setOtherShortValue(document.shortName);
                }
            } else {
                setShortNameValue('');
                setOtherShortValue('');
            }
            
            if ( document.id ) {
                setIdValue(document.id);
            } else {
                setIdValue('');
            }
            // setErrorMessage('');
            // loadInstanceConfiguration(document);
        } else {
            setNameValue('');
            setIdValue('');
            setShortNameValue('');
            setDescriptionValue('');
            setTypeValue('None');
            setOtherValue('');
            setOtherShortValue('');
            setConfig(null);
            // setErrorMessage('Please set required fields');
            // setOkEnabled(false);
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'GEN', openWorkflowId: instance?.id}));
        // }

    },[document]);

    useEffect( () => {
        if (Array.isArray(documentList)) {
            const dl = documentList.map( d => d.id);
            setDocNameList(dl);
        } else {
            setDocNameList([]);
            netGet('/api/doc/roots?sort=alpha')
                .then(response => response.json())
                .then(docs => {
                    if (Array.isArray(docs)) {
                        const dl = docs.map( d => d.id);
                        setDocNameList(dl);
                        /*
                        netGet('/api/workflow/inst/find/bystate/MGT_DOC')
                            .then(resp => resp.json())
                            .then(insts => {
                                // console.log('Got create workflow documents: ' + JSON.stringify(insts));
                                if (Array.isArray(insts)) {
                                    const dinsts = insts.map(wi => {
                                        return {
                                            id: wi.properties?.document,
                                            document: wi.properties?.document,
                                            title: wi.properties?.instanceName,
                                            workflowInstance: wi,
                                            docType: 'MGT_DOC', // as oppose to DDIS

                                        };
                                    });
                                    const dss = [...docs, ...dinsts];
                                    dss.sort((a, b) => a.title.localeCompare(b.title));
                                    // console.log('ALL documents: ' + JSON.stringify(dss));
                                    // const q = dss.find( d => d.id === 'NZ_QRH');
                                    // console.log("QRH DOC: " + JSON.stringify(q));
                                    const dl = dss.map(d => d.id);
                                    setDocNameList(dl);
                                }
                            }).catch(err => {
                                console.log('Error fetching management create document workflows: ' + err);
                            });
                        */
                    }
                }).catch(error => {
                    console.log('Error fetching profiles: ' + error);
                });
        }
    },[documentList]);

    /*
    const loadInstanceConfiguration = (inst) => {
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.id) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config);
                    const m = config.properties?.general?.model ? config.properties.general.model : '';
                    setTypeValue(m);
                    const om = config.properties?.general?.otherModel ? config.properties.general.otherModel : '';
                    setOtherValue(om);
                    const s = config.properties?.general?.shortName ? config.properties.general.shortName : '';
                    setShortNameValue(s);
                    const os = config.properties?.general?.otherShortName ? config.properties.general.otherShortName : '';
                    setOtherShortValue(os);
                    if ( config.description ) {
                        setDescriptionValue(config.description);
                    }
                    let n = config.properties?.general?.displayName ? config.properties?.general?.displayName : inst.properties?.instanceName;
                    if ( !n ) {
                        n = '';
                    }
                    computeOkEnable(inst.properties?.document, n, m, om, s, os);
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };
    */

    const computeOkEnable = (docid, name, model, otherModel, shortName, otherShortName ) => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        let value = true;
        let message = '';
        if ( docid !== document?.id ) {
            if ( Array.isArray(docNameList) ) {
                const di = docNameList.find( d => d === docid);
                if ( di && di !== document.id ) {
                    value = false;
                    console.log('Found duplicate doc id = ' + di + ' DOCS: ' + JSON.stringify(docNameList));
                    // setErrorMessage('Identifier already in use')
                    message = 'Identifier already in use';
                }
            }
        }
        if ( !name || name.trim() === '') {
            value = false;
            // console.log('Name is not valid');
            // setErrorMessage('Please set required fields');
            message = 'Please set required fields';
        }
        if ( !model || model.trim() === '') {
            value = false;
            // console.log('Type is not valid');
        } else if ( model === 'Other' ) {
            if (!otherModel || otherModel.trim() === '') {
                value = false;
                // console.log('Other type is not valid');
                // setErrorMessage('Please set required fields');
                message = 'Please set required fields';
            }
        }
        if ( !shortName || shortName.trim() === '') {
            value = false;
            // console.log('shortName is not valid');
            // setErrorMessage('Please set required fields');
            message = 'Please set required fields';
        } else if ( shortName === 'Other' ) {
            if ( !otherShortName || otherShortName.trim() === '') {
                value = false;
                // console.log('Other shortName is not valid');
                // setErrorMessage('Please set required fields');
                message = 'Please set required fields';
            }
        }
        if ( value ) {
            setErrorMessage('');
        }
        return {valid: value, message: message};
        // console.log('OK enabled = ' + value);
        // setOkEnabled(value);
    };


    /*
    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = {
                configId: config ? config.id : null,
                name: nameValue,
                description: descriptionValue,
                type: typeValue,
                shortName: shortNameValue,
                id: idValue,
                otherProps: config ? config.properties : null,
            };
            if ( typeValue === 'Other') {
                vv['other'] = otherValue;
            }
            if ( shortNameValue === 'Other' ) {
                vv['otherShortName'] = otherShortValue;
            }
            onSave(vv, action);
        }
    }
    */

    /*
    const onNextClick = () => {
        onOKClick('NEXT');
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };
    */

    const nameChanged = (event) => {
        setNameValue(event.target.value);
        const status = computeOkEnable(idValue, event.target.value, typeValue, otherValue, shortNameValue, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                name: event.target.value,
                description: descriptionValue,
                id: idValue,
                type: typeValue,
                shortName: shortNameValue,
                status: status,
            });
        }
    };

    const descriptionChanged = (event) => {
        setDescriptionValue(event.target.value);
        const status = computeOkEnable(idValue, nameValue, typeValue, otherValue, shortNameValue, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                name: nameValue,
                description: event.target.value,
                id: idValue,
                type: typeValue,
                shortName: shortNameValue,
                status: status,
            });
        }
    };

    const handleTypeChange = (event) => {
        setTypeValue(event.target.value);
        computeIdValue(event.target.value, otherValue, shortNameValue, otherShortValue);
        const status = computeOkEnable(idValue, nameValue, event.target.value, otherValue, shortNameValue, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                name: nameValue,
                description: descriptionValue,
                id: idValue,
                type: typeValue,
                shortName: shortNameValue,
                status: status,
            });
        }
    };

    const otherChanged = (event) => {
        setOtherValue(event.target.value);
        computeIdValue(typeValue, event.target.value, shortNameValue, otherShortValue);
    };

    const handleShortNameChange = (event) => {
        setShortNameValue(event.target.value);
        const id = computeIdValue(typeValue, otherValue, event.target.value, otherShortValue);
        const status = computeOkEnable(id, nameValue, typeValue, otherValue, event.target.value, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                name: nameValue,
                description: descriptionValue,
                id: id,
                type: typeValue,
                shortName: event.target.value,
                status: status,
            });
        }
    };

    const otherShortChanged = (event) => {
        setOtherShortValue(event.target.value);
        const id = computeIdValue(typeValue, otherValue, shortNameValue, event.target.value);
        const status = computeOkEnable(id, nameValue, typeValue, otherValue, shortNameValue, event.target.value);
        if ( typeof onChange === 'function') {
            onChange({
                name: nameValue,
                description: descriptionValue,
                id: id,
                type: typeValue,
                shortName: event.target.value,
                status: status,
            });
        }
    };

    const idValueChanged = (event) => {
        setIdValue(event.target.value);
        const status = computeOkEnable(event.target.value, nameValue, typeValue, otherValue, shortNameValue, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                name: nameValue,
                description: descriptionValue,
                id: event.target.value,
                type: typeValue,
                shortName: shortNameValue,
                status: status,
            });
        }
    };

    const computeIdValue = (t, to, s, so) => {
        const tt = t === 'Other' ? to : t;
        const tti = tt.trim() === '' || tt.trim() === 'None' ? '' : `_${tt}`;
        const ss = s === 'Other' ? so : s;
        let id = `${operator}${tti}_${ss}`;
        // check is not already used
        if ( id !== document?.id ) { // this one is ok
            if ( Array.isArray(docNameList) ) {
                let di = docNameList.find( d => d === id);
                let i = 1;
                let nid = id;
                while ( di && i < 40) {
                    if ( i < 10 ) {
                        nid = `${id}_0${i}`;
                    } else {
                        nid = `${id}_${i}`;
                    }
                    di = docNameList.find( d => d === nid);
                    i++;
                }
                id = nid;
            }
        }
        setIdValue(id);
        return id;
    };

    return (
        <Box sx={{mt: 2}}>
            <Box sx={{ paddingTop: '2em' }}>
                <TextField label="Name *" value={nameValue} onChange={nameChanged} size="small" fullWidth
                    helperText="Display name"
                />
            </Box>
            <Box sx={{ paddingTop: '3ex' }}>
                <TextField label="Description" value={descriptionValue} onChange={descriptionChanged} size="small"
                    multiline fullWidth
                    rows={3} />
            </Box>

            <Box sx={{ paddingTop: 1 }}>

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em', minWidth: '7.5em' }}>Type *:</Typography>
                    <FormControl sx={{ m: 1, minWidth: 120, marginLeft: 0 }} size="small">
                        <Select
                            value={typeValue}
                            onChange={handleTypeChange}
                            sx={{ minWidth: '160px' }}
                            MenuProps={TypeMenuProps}
                        >
                            {DOCUMENT_TYPES.map(dt =>
                                <MenuItem key={`DT-${dt}`}
                                    value={dt}>
                                    {dt}
                                </MenuItem>
                            )}

                        </Select>
                    </FormControl>
                    {typeValue === 'Other' &&
                        <TextField label="Type" value={otherValue} onChange={otherChanged} size="small" fullWidth sx={{ marginLeft: 8 }} />
                    }
                </Box>
                <Typography sx={{ fontSize: '80%', color: 'gray' }}>Aircraft type or model</Typography>
            </Box>
            <Box sx={{ paddingTop: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7.5em', minWidth: '7em' }}>Short Name *:</Typography>
                    <FormControl sx={{ m: 1, minWidth: 120, marginLeft: 0 }} size="small">
                        <Select
                            value={shortNameValue}
                            onChange={handleShortNameChange}
                            sx={{ minWidth: '160px' }}
                            MenuProps={TypeMenuProps}
                        >
                            {SHORT_NAMES.map(dt =>
                                <MenuItem key={`DT-${dt}`}
                                    value={dt}>
                                    {dt}
                                </MenuItem>
                            )}

                        </Select>
                    </FormControl>
                    {shortNameValue === 'Other' &&
                        <TextField label="Short Name" value={otherShortValue} onChange={otherShortChanged} size="small" fullWidth sx={{ marginLeft: 8 }} />
                    }
                </Box>
                <Typography sx={{ fontSize: '80%', color: 'gray' }}>Document short name or abbreviation</Typography>
            </Box>
            <Box sx={{ paddingTop: 3 }}>
                <TextField label="Identifier *" value={idValue} onChange={idValueChanged} size="small" fullWidth />
            </Box>

            {/* !editOnly &&
                    <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '5.5em' }}>Template:</Typography>
                        {Array.isArray(template) ?

                            <FormControl sx={{ m: 1, minWidth: '350px', width: '400px' }} size="small">
                                <Select
                                    value={templateValue}
                                    onChange={handleTemplateChange}
                                    sx={{ minWidth: '350px', width: '400px' }}
                                    MenuProps={CreateMenuProps}
                                >
                                    {template.map((templateName) => (
                                        <MenuItem
                                            key={'cswd' + templateName}
                                            value={templateName}
                                        >
                                            {templateName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            :

                            <Typography sx={{ paddingLeft: '1em' }}>{template}</Typography>
                        }
                    </Box>
                */}
        </Box>

    );

}

function EditDocumentGeneralPanel(props) {
    const {
        title = 'General Information',
        document,
        documentList,
        onChange,
        readOnly=false,
        ...other
    } = props;

    const [nameValue, setNameValue] = useState('');
    const [shortNameValue, setShortNameValue] = useState('');
    const [descriptionValue, setDescriptionValue] = useState('');
    const [typeValue, setTypeValue] = useState('None');
    const [otherValue, setOtherValue] = useState('');
    const [otherShortValue, setOtherShortValue] = useState('');
    const [idValue, setIdValue] = useState('');
    const [config, setConfig] = useState(null); // DLib config id (Long)
    const [docNameList, setDocNameList] = useState([]);
    const [operator, setOperator] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    // const document = useSelector((state) => state.documentConfig.general);
    // const dispatch = useDispatch();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };

    const DocMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                minWidth: 300,
            },
        },
    };

    useEffect( () => {
        netGet('/config/realm')
            .then(response => response.json())
            .then(rinfo => {
                if ( rinfo?.realm ) {
                    setOperator(rinfo.realm);
                }
            }).catch ( error => {
                console.log('Error fetching realm name: ' + error);
            });
    },[]);

    useEffect( () => {
        if ( document ) {
            if ( document.title ) {
                setNameValue(document.title);
            } else {
                setNameValue('');
            }
            if ( document.description ) {
                setDescriptionValue(document.description);
            } else {
                setDescriptionValue('');
            }
            if ( document.type ) {
                if (DOCUMENT_TYPES.includes(document.type) ) {
                    setTypeValue(document.type);
                    setOtherValue('');
                } else {
                    setTypeValue('Other');
                    setOtherValue(document.type);
                }
            } else {
                setTypeValue('None');
                setOtherValue('');
            }
            if ( document.shortName ) {
                if ( SHORT_NAMES.includes(document.shortName) ) {
                    setShortNameValue(document.shortName);
                    setOtherShortValue('');
                } else {
                    setShortNameValue('Other');
                    setOtherShortValue(document.shortName);
                }
            } else {
                setShortNameValue('');
                setOtherShortValue('');
            }
            
            if ( document.id ) {
                setIdValue(document.id);
            } else {
                setIdValue('');
            }
            // setErrorMessage('');
            loadInstanceConfiguration(document);
        } else {
            setNameValue('');
            setIdValue('');
            setShortNameValue('');
            setDescriptionValue('');
            setTypeValue('None');
            setOtherValue('');
            setOtherShortValue('');
            setConfig(null);
            // setErrorMessage('Please set required fields');
            // setOkEnabled(false);
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'GEN', openWorkflowId: instance?.id}));
        // }

    },[document]);

    useEffect( () => {
        if (Array.isArray(documentList)) {
            const dl = documentList.map( d => d.id);
            setDocNameList(dl);
        } else {
            setDocNameList([]);
            netGet('/api/doc/roots?sort=alpha')
                .then(response => response.json())
                .then(docs => {
                    if (Array.isArray(docs)) {
                        const dl = docs.map( d => d.id);
                        setDocNameList(dl);
                        /*
                        netGet('/api/workflow/inst/find/bystate/MGT_DOC')
                            .then(resp => resp.json())
                            .then(insts => {
                                // console.log('Got create workflow documents: ' + JSON.stringify(insts));
                                if (Array.isArray(insts)) {
                                    const dinsts = insts.map(wi => {
                                        return {
                                            id: wi.properties?.document,
                                            document: wi.properties?.document,
                                            title: wi.properties?.instanceName,
                                            workflowInstance: wi,
                                            docType: 'MGT_DOC', // as oppose to DDIS

                                        };
                                    });
                                    const dss = [...docs, ...dinsts];
                                    dss.sort((a, b) => a.title.localeCompare(b.title));
                                    // console.log('ALL documents: ' + JSON.stringify(dss));
                                    // const q = dss.find( d => d.id === 'NZ_QRH');
                                    // console.log("QRH DOC: " + JSON.stringify(q));
                                    const dl = dss.map(d => d.id);
                                    setDocNameList(dl);
                                }
                            }).catch(err => {
                                console.log('Error fetching management create document workflows: ' + err);
                            });
                        */
                    }
                }).catch(error => {
                    console.log('Error fetching profiles: ' + error);
                });
        }
    },[documentList]);

    
    const loadInstanceConfiguration = (inst) => {
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.id) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config);
                    const m = config.properties?.general?.model ? config.properties.general.model : '';
                    setTypeValue(m);
                    const om = config.properties?.general?.otherModel ? config.properties.general.otherModel : '';
                    setOtherValue(om);
                    const s = config.properties?.general?.shortName ? config.properties.general.shortName : '';
                    setShortNameValue(s);
                    const os = config.properties?.general?.otherShortName ? config.properties.general.otherShortName : '';
                    setOtherShortValue(os);
                    if ( config.description ) {
                        setDescriptionValue(config.description);
                    } else if ( config.properties?.general?.description ) {
                        setDescriptionValue(config.properties.general.description);
                    }
                    let n = config.properties?.general?.displayName ? config.properties?.general?.displayName : inst.properties?.instanceName;
                    if ( !n ) {
                        n = '';
                    }
                    computeOkEnable(inst.properties?.document, n, m, om, s, os);
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };
    

    const computeOkEnable = (docid, name, model, otherModel, shortName, otherShortName ) => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        let value = true;
        let message = '';
        if ( docid !== document?.id ) {
            if ( Array.isArray(docNameList) ) {
                const di = docNameList.find( d => d === docid);
                if ( di && di !== document.id ) {
                    value = false;
                    console.log('Found duplicate doc id = ' + di + ' DOCS: ' + JSON.stringify(docNameList));
                    // setErrorMessage('Identifier already in use')
                    message = 'Identifier already in use';
                }
            }
        }
        if ( !name || name.trim() === '') {
            value = false;
            // console.log('Name is not valid');
            // setErrorMessage('Please set required fields');
            message = 'Please set required fields';
        }
        if ( !model || model.trim() === '') {
            value = false;
            // console.log('Type is not valid');
        } else if ( model === 'Other' ) {
            if (!otherModel || otherModel.trim() === '') {
                value = false;
                // console.log('Other type is not valid');
                // setErrorMessage('Please set required fields');
                message = 'Please set required fields';
            }
        }
        if ( !shortName || shortName.trim() === '') {
            value = false;
            // console.log('shortName is not valid');
            // setErrorMessage('Please set required fields');
            message = 'Please set required fields';
        } else if ( shortName === 'Other' ) {
            if ( !otherShortName || otherShortName.trim() === '') {
                value = false;
                // console.log('Other shortName is not valid');
                // setErrorMessage('Please set required fields');
                message = 'Please set required fields';
            }
        }
        if ( value ) {
            setErrorMessage('');
        }
        return {valid: value, message: message};
        // console.log('OK enabled = ' + value);
        // setOkEnabled(value);
    };


    /*
    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = {
                configId: config ? config.id : null,
                name: nameValue,
                description: descriptionValue,
                type: typeValue,
                shortName: shortNameValue,
                id: idValue,
                otherProps: config ? config.properties : null,
            };
            if ( typeValue === 'Other') {
                vv['other'] = otherValue;
            }
            if ( shortNameValue === 'Other' ) {
                vv['otherShortName'] = otherShortValue;
            }
            onSave(vv, action);
        }
    }
    */

    /*
    const onNextClick = () => {
        onOKClick('NEXT');
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };
    */

    const nameChanged = (event) => {
        setNameValue(event.target.value);
        const status = computeOkEnable(idValue, event.target.value, typeValue, otherValue, shortNameValue, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                title: event.target.value,
                description: descriptionValue,
                id: idValue,
                type: typeValue,
                shortName: shortNameValue,
                status: status,
            });
        }
    };

    const descriptionChanged = (event) => {
        setDescriptionValue(event.target.value);
        const status = computeOkEnable(idValue, nameValue, typeValue, otherValue, shortNameValue, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                title: nameValue,
                description: event.target.value,
                id: idValue,
                type: typeValue,
                shortName: shortNameValue,
                status: status,
            });
        }
    };

    const handleTypeChange = (event) => {
        setTypeValue(event.target.value);
        computeIdValue(event.target.value, otherValue, shortNameValue, otherShortValue);
        const status = computeOkEnable(idValue, nameValue, event.target.value, otherValue, shortNameValue, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                name: nameValue,
                description: descriptionValue,
                id: idValue,
                type: typeValue,
                shortName: shortNameValue,
                status: status,
            });
        }
    };

    const otherChanged = (event) => {
        setOtherValue(event.target.value);
        computeIdValue(typeValue, event.target.value, shortNameValue, otherShortValue);
    };

    const handleShortNameChange = (event) => {
        setShortNameValue(event.target.value);
        const id = computeIdValue(typeValue, otherValue, event.target.value, otherShortValue);
        const status = computeOkEnable(id, nameValue, typeValue, otherValue, event.target.value, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                name: nameValue,
                description: descriptionValue,
                id: id,
                type: typeValue,
                shortName: event.target.value,
                status: status,
            });
        }
    };

    const otherShortChanged = (event) => {
        setOtherShortValue(event.target.value);
        const id = computeIdValue(typeValue, otherValue, shortNameValue, event.target.value);
        const status = computeOkEnable(id, nameValue, typeValue, otherValue, shortNameValue, event.target.value);
        if ( typeof onChange === 'function') {
            onChange({
                name: nameValue,
                description: descriptionValue,
                id: id,
                type: typeValue,
                shortName: event.target.value,
                status: status,
            });
        }
    };

    const idValueChanged = (event) => {
        setIdValue(event.target.value);
        const status = computeOkEnable(event.target.value, nameValue, typeValue, otherValue, shortNameValue, otherShortValue);
        if ( typeof onChange === 'function') {
            onChange({
                name: nameValue,
                description: descriptionValue,
                id: event.target.value,
                type: typeValue,
                shortName: shortNameValue,
                status: status,
            });
        }
    };

    const computeIdValue = (t, to, s, so) => {
        const tt = t === 'Other' ? to : t;
        const tti = tt.trim() === '' || tt.trim() === 'None' ? '' : `_${tt}`;
        const ss = s === 'Other' ? so : s;
        let id = `${operator}${tti}_${ss}`;
        // check is not already used
        if ( id !== document?.id ) { // this one is ok
            if ( Array.isArray(docNameList) ) {
                let di = docNameList.find( d => d === id);
                let i = 1;
                let nid = id;
                while ( di && i < 40) {
                    if ( i < 10 ) {
                        nid = `${id}_0${i}`;
                    } else {
                        nid = `${id}_${i}`;
                    }
                    di = docNameList.find( d => d === nid);
                    i++;
                }
                id = nid;
            }
        }
        setIdValue(id);
        return id;
    };

    return (
        <Box sx={{mt: 2}}>
            <Box sx={{ paddingTop: '2em' }}>
                <TextField label="Name" value={nameValue} onChange={nameChanged} size="small" sx={{width: '50%'}}
                    slotProps={{
                        input: {
                            readOnly: readOnly,
                        }
                    }}
                    helperText="Display name"
                />
            </Box>
            <Box sx={{ paddingTop: '3ex' }}>
                <TextField label="Description" value={descriptionValue} onChange={descriptionChanged} size="small"
                    slotProps={{
                        input: {
                            readOnly: readOnly,
                        }
                    }}
                    multiline sx={{width: '50%'}}
                    rows={3} />
            </Box>

            
            <Box sx={{ paddingTop: 3 }}>
                <TextField label="Identifier" value={idValue} onChange={idValueChanged} size="small" sx={{width: '50%'}}
                    slotProps={{
                        input: {
                            readOnly: true,
                        },
                    }}
                    />
            </Box>

        </Box>

    );

}

function CreateDocumentSchemaDialog(props) {
    const {
        title = 'Create Document—Schema',
        instance = null,
        open,
        onSave,
        onCancel,
        initial=true, // whether this is the initial create document dialog outside of workflow
        ...other
    } = props;

    const [schemaValue, setSchemaValue] = useState('');
    const [labelValue, setLabelValue] = useState('');
    const [styleValue, setStyleValue] = useState('');
    const [schemaList, setSchemaList] = useState(DEFAULT_SCHEMAS);
    const [styleList, setStyleList] = useState(DEFAULT_STYLES);
    const [okEnabled, setOkEnabled] = useState(false);
    const [config, setConfig] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };

    useEffect( () => {
        netGet('/api/doc/schema/list')
            .then(resp => resp.json())
            .then(schemas => {
                if ( Array.isArray(schemas) ) {
                    // console.log('SCHEMAS: ' + JSON.stringify(schemas));
                    schemas.sort( (a,b) => a.name.localeCompare(b.name));
                    setSchemaList(schemas);
                }
            }).catch(error => {
                console.log('Failed to retrieve schema list: ' + error);
            });
        netGet('/api/doc/style/list')
            .then(resp => resp.json())
            .then(styles => {
                if ( Array.isArray(styles) ) {
                    // console.log('STYLES: ' + JSON.stringify(styles));                    
                    styles.sort( (a,b) => a.name.localeCompare(b.name));
                    setStyleList(styles);                    
                }
            }).catch(error => {
                console.log('Failed to retrieve styles list: ' + error);
            }); 
    }, []);

    useEffect( () => {
        if ( open && instance ) {
            loadInstanceConfiguration(instance);
        } else {
            setSchemaValue('');
            setStyleValue('');
            setOkEnabled(false);
            setErrorMessage('Please set required fields.');
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'SCH', openWorkflowId: instance?.id}));
        // }
    },[open, instance]);

    const loadInstanceConfiguration = (inst) => {
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.properties?.document) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config); // save original config object so we don't use other configuration
                    const m = config.properties?.schema?.schemaName ? config.properties.schema.schemaName : '';
                    setSchemaValue(m);
                    const s = config.properties?.schema?.schemaLabel ? config.properties.schema.schemaLabel : '';
                    setLabelValue(s);
                    const os = config.properties?.schema?.styleName ? config.properties.schema.styleName : '';
                    setStyleValue(os);
                    
                    computeOkEnable(m, s, os);
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = (name, label, style ) => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        let value = true;
        if ( !name || name.trim() === '') {
            value = false;
            console.log('Schema Name is not valid');
            setErrorMessage('Please set required fields.');
        }
        if ( !label || label.trim() === '') {
            value = false;
            console.log('Label is not valid');
            setErrorMessage('Please set required fields.');
        }
        if ( !style || style.trim() === '') {
            value = false;
            console.log('Style Name is not valid');
            setErrorMessage('Please set required fields.');
        } 
        if ( value ) {
            setErrorMessage('');
        }
        //console.log('OK enabled = ' + value);
        setOkEnabled(value);
    };

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = { ...config };
            if ( !vv.properties) {
                vv.properties = {};
            }
            if ( !vv.properties.schema) {
                vv.properties.schema = {};
            }
            vv.properties.schema.schemaName = schemaValue;
            vv.properties.schema.schemaLabel = labelValue;
            vv.properties.schema.styleName = styleValue;
            const schema = schemaList.find( s => s.id === schemaValue);
            if ( schema ) {
                vv.properties.schema.schemaInfo = schema;
            }
            const style = styleList.find( s => s.name === styleValue);
            if ( style ) {
                vv.properties.schema.styleInfo = style;
            }
            onSave(vv, action);
        }
    };

    const onNextClick = () => {
        onOKClick('NEXT');
    }

    const onPreviousClick = () => {
        const action = okEnabled ? 'PREV_OK' : 'PREV_CANCEL';
        onOKClick(action);
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const schemaChanged = (event) => {
        setSchemaValue(event.target.value);
        const ss = schemaList.find( s => s.id === event.target.value);
        const label = ss ? ss.name : '';
        // console.log('Schema changed: ' + event.target.value + ' : ' + JSON.stringify(ss));
        setLabelValue(label);
        computeOkEnable(event.target.value, label, styleValue);
    };

    const styleChanged = (event) => {
        setStyleValue(event.target.value);
        computeOkEnable(schemaValue, labelValue, event.target.value);
    };


    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { 
                    sx: {
                        minWidth: 800,
                        maxHeight: 600
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', paddingTop: '2ex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="outlined" onClick={onPreviousClick} sx={{minWidth: '9.5em'}} startIcon={<ArrowBackIosIcon/>}>Previous</Button>
                    <Button variant="outlined" onClick={onNextClick} sx={{minWidth: '9.5em'}} disabled={!okEnabled} endIcon={<ArrowForwardIosIcon/>}>Next</Button>
                </Box>

                <Box sx={{paddingTop: 4}}>
 
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '7em', minWidth: '7em' }}>Schema:</Typography>
                        <FormControl sx={{ m: 1, minWidth: '15em', maxWidth: '100%', marginLeft: 0 }} size="small">
                            <Select
                                value={schemaValue}
                                onChange={schemaChanged}
                                sx={{ minWidth: '15em' }}
                                MenuProps={TypeMenuProps}
                            >
                                {schemaList.map(ss =>
                                    <MenuItem key={`CDS-${ss.id}`}
                                        value={ss.id}>
                                        {ss.name}
                                    </MenuItem>
                                )}
                                
                            </Select>
                        </FormControl>
                        
                    </Box>

                </Box>
                <Box sx={{paddingTop: 2}}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '7em', minWidth: '7em' }}>Style:</Typography>
                        <FormControl sx={{ m: 1, minWidth: '15em', maxWidth: '100%', marginLeft: 0 }} size="small">
                            <Select
                                value={styleValue}
                                onChange={styleChanged}
                                sx={{ minWidth: '15em' }}
                                MenuProps={TypeMenuProps}
                            >
                                {styleList.map(ss =>
                                    <MenuItem key={`CDSS-${ss.name}`}
                                        value={ss.name}>
                                        {ss.name}
                                    </MenuItem>
                                )}
                                
                            </Select>
                        </FormControl>
                        
                    </Box>
                </Box>

            </DialogContent>
            <DialogActions sx={{padding: 3, display: 'flex', justifyContent: 'space-between'}}>
                <Typography color="warning">{errorMessage}</Typography>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );

}

function CreateDocumentSchemaPanel(props) {
    const {
        title = 'Create Document—Schema',
        onChange,
        onCancel,
        initial=true, // whether this is the initial create document dialog outside of workflow
        ...other
    } = props;

    const [schemaValue, setSchemaValue] = useState('');
    const [labelValue, setLabelValue] = useState('');
    const [styleValue, setStyleValue] = useState('');
    const [schemaList, setSchemaList] = useState(DEFAULT_SCHEMAS);
    const [styleList, setStyleList] = useState(DEFAULT_STYLES);
    const [okEnabled, setOkEnabled] = useState(false);
    const [config, setConfig] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const schema = useSelector((state) => state.documentConfig.schema);
    // const dispatch = useDispatch();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };

    useEffect( () => {
        netGet('/api/doc/schema/list')
            .then(resp => resp.json())
            .then(schemas => {
                if ( Array.isArray(schemas) ) {
                    // console.log('SCHEMAS: ' + JSON.stringify(schemas));
                    const ss = schemas.filter ( s => s.id.toLowerCase().includes('efb') || s.id.toLowerCase().includes('qrh'));
                    ss.sort( (a,b) => a.name.localeCompare(b.name));
                    setSchemaList(ss);
                }
            }).catch(error => {
                console.log('Failed to retrieve schema list: ' + error);
            });
        netGet('/api/doc/style/list')
            .then(resp => resp.json())
            .then(styles => {
                if ( Array.isArray(styles) ) {
                    // console.log('STYLES: ' + JSON.stringify(styles));                    
                    styles.sort( (a,b) => a.name.localeCompare(b.name));
                    setStyleList(styles);                    
                }
            }).catch(error => {
                console.log('Failed to retrieve styles list: ' + error);
            }); 
    }, []);

    useEffect( () => {
        if ( schema ) {
            // loadInstanceConfiguration(instance);
            let schemaName = '';
            if ( schema.schemaName ) {
                setSchemaValue(schema.schemaName);
                schemaName = schema.schemaName;
            } else {
                setSchemaValue('');
            }
            let schemaLabel = '';
            if ( schema.schemaLabel ) {
                setLabelValue(schema.schemaLabel);
                schemaLabel = schema.schemaLabel;
            } else {
                setLabelValue('');
            }
            let styleName = '';
            if ( schema.styleName ) {
                setStyleValue(schema.styleName);
                styleName = schema.styleName;
            }
            console.log('SCH doc = schemaName=' + schemaName + ', label=' + schemaLabel + ', style=' + styleName);
            computeOkEnable(schemaName, schemaLabel, styleName);
        } else {
            setSchemaValue('');
            setLabelValue('');
            setStyleValue('');
            setOkEnabled(false);
            setErrorMessage('Please set required fields.');
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'SCH', openWorkflowId: instance?.id}));
        // }
    },[schema]);

    const loadInstanceConfiguration = (inst) => {
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.properties?.document) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config); // save original config object so we don't use other configuration
                    const m = config.properties?.schema?.schemaName ? config.properties.schema.schemaName : '';
                    setSchemaValue(m);
                    const s = config.properties?.schema?.schemaLabel ? config.properties.schema.schemaLabel : '';
                    setLabelValue(s);
                    const os = config.properties?.schema?.styleName ? config.properties.schema.styleName : '';
                    setStyleValue(os);
                    
                    computeOkEnable(m, s, os);
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = (name, label, style ) => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        let value = true;
        let message = '';
        if ( !name || name.trim() === '') {
            value = false;
            // console.log('Schema Name is not valid');
            // setErrorMessage('Please set required fields.');
            message = 'Please set required fields.';
        }
        if ( !label || label.trim() === '') {
            value = false;
            // console.log('Label is not valid');
            // setErrorMessage('Please set required fields.');
            message = 'Please set required fields.';
        }
        if ( !style || style.trim() === '') {
            value = false;
            // console.log('Style Name is not valid');
            // setErrorMessage('Please set required fields.');
            message = 'Please set required fields.';
        } 
        if ( value ) {
            // setErrorMessage('');
            message = '';
        }
        //console.log('OK enabled = ' + value);
        setOkEnabled(value);
        setErrorMessage(message);
        return {schemaValid: value, message: message };
    };

    /*
    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = { ...config };
            if ( !vv.properties) {
                vv.properties = {};
            }
            if ( !vv.properties.schema) {
                vv.properties.schema = {};
            }
            vv.properties.schema.schemaName = schemaValue;
            vv.properties.schema.schemaLabel = labelValue;
            vv.properties.schema.styleName = styleValue;
            const schema = schemaList.find( s => s.id === schemaValue);
            if ( schema ) {
                vv.properties.schema.schemaInfo = schema;
            }
            const style = styleList.find( s => s.name === styleValue);
            if ( style ) {
                vv.properties.schema.styleInfo = style;
            }
            onSave(vv, action);
        }
    };
    */

    const schemaChanged = (event) => {
        setSchemaValue(event.target.value);
        const ss = schemaList.find( s => s.id === event.target.value);
        const sty = styleList.find( s => s.name === styleValue);
        const label = ss ? ss.name : '';
        // console.log('Schema changed: ' + event.target.value + ' : ' + JSON.stringify(ss));
        setLabelValue(label);
        const status = computeOkEnable(event.target.value, label, styleValue);
        if ( typeof onChange === 'function') {
            const sch= schema ? {...schema} : {};
            sch.schemaName = event.target.value;
            sch.schemaLabel = label;
            sch.styleName = styleValue;
            sch.schemaInfo = ss;
            sch.styleInfo = sty;
            sch.status = status;
            onChange(sch);
        }
    };

    const styleChanged = (event) => {
        setStyleValue(event.target.value);
        const sty = styleList.find( s => s.name === event.target.value);
        const ss = schemaList.find( s => s.id === schemaValue);
        const status = computeOkEnable(schemaValue, labelValue, event.target.value);
        if ( typeof onChange === 'function') {
            const sch = schema ? {...schema} : {};

            sch.schemaName = schemaValue;
            sch.schemaLabel = labelValue;
            sch.styleName = event.target.value;
            sch.styleInfo = sty;
            sch.schemaInfo = ss;
            sch.status = status;

            onChange(sch);
        }
    };




    return (
        <Box>
            <Box sx={{ paddingTop: 4 }}>

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em', minWidth: '7em' }}>Schema *:</Typography>
                    <FormControl sx={{ m: 1, minWidth: '15em', maxWidth: '100%', marginLeft: 0 }} size="small">
                        <Select
                            value={schemaValue}
                            onChange={schemaChanged}
                            sx={{ minWidth: '15em' }}
                            MenuProps={TypeMenuProps}
                        >
                            {schemaList.map(ss =>
                                <MenuItem key={`CDS-${ss.id}`}
                                    value={ss.id}>
                                    {ss.name}
                                </MenuItem>
                            )}

                        </Select>
                    </FormControl>

                </Box>

            </Box>
            <Box sx={{ paddingTop: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em', minWidth: '7em' }}>Style *:</Typography>
                    <FormControl sx={{ m: 1, minWidth: '15em', maxWidth: '100%', marginLeft: 0 }} size="small">
                        <Select
                            value={styleValue}
                            onChange={styleChanged}
                            sx={{ minWidth: '15em' }}
                            MenuProps={TypeMenuProps}
                        >
                            {styleList.map(ss =>
                                <MenuItem key={`CDSS-${ss.name}`}
                                    value={ss.name}>
                                    {ss.name}
                                </MenuItem>
                            )}

                        </Select>
                    </FormControl>

                </Box>
            </Box>

        </Box>

    );

}

function EditDocumentSchemaPanel(props) {
    const {
        title = 'Schema',
        document,
        open,
        onChange,
        onCancel,
        readOnly,
        initial=true, // whether this is the initial create document dialog outside of workflow
        ...other
    } = props;

    const [schemaValue, setSchemaValue] = useState('');
    const [labelValue, setLabelValue] = useState('');
    const [styleValue, setStyleValue] = useState('');
    const [schemaList, setSchemaList] = useState(DEFAULT_SCHEMAS);
    const [styleList, setStyleList] = useState(DEFAULT_STYLES);
    const [okEnabled, setOkEnabled] = useState(false);
    const [config, setConfig] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    // const schema = useSelector((state) => state.documentConfig.schema);
    // const dispatch = useDispatch();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };

    useEffect( () => {
        netGet('/api/doc/schema/list')
            .then(resp => resp.json())
            .then(schemas => {
                if ( Array.isArray(schemas) ) {
                    
                    const ss = schemas.filter ( s => s.id.toLowerCase().includes('efb') || s.id.toLowerCase().includes('qrh'));
                    ss.sort( (a,b) => a.name.localeCompare(b.name));
                    console.log('SCHEMAS: ' + JSON.stringify(ss));
                    setSchemaList(ss);
                }
            }).catch(error => {
                console.log('Failed to retrieve schema list: ' + error);
            });
        netGet('/api/doc/style/list')
            .then(resp => resp.json())
            .then(styles => {
                if ( Array.isArray(styles) ) {
                    // console.log('STYLES: ' + JSON.stringify(styles));                    
                    styles.sort( (a,b) => a.name.localeCompare(b.name));
                    setStyleList(styles);                    
                }
            }).catch(error => {
                console.log('Failed to retrieve styles list: ' + error);
            }); 
    }, []);

    useEffect( () => {
        if ( open && document) {
            loadInstanceConfiguration(document);
            /*
            let schemaName = '';
            if ( schema.schemaName ) {
                setSchemaValue(schema.schemaName);
                schemaName = schema.schemaName;
            } else {
                setSchemaValue('');
            }
            let schemaLabel = '';
            if ( schema.schemaLabel ) {
                setLabelValue(schema.schemaLabel);
                schemaLabel = schema.schemaLabel;
            } else {
                setLabelValue('');
            }
            let styleName = '';
            if ( schema.styleName ) {
                setStyleValue(schema.styleName);
                styleName = schema.styleName;
            }
            console.log('SCH doc = schemaName=' + schemaName + ', label=' + schemaLabel + ', style=' + styleName);
            computeOkEnable(schemaName, schemaLabel, styleName);
            */
        } else {
            setSchemaValue('');
            setLabelValue('');
            setStyleValue('');
            setOkEnabled(false);
            setErrorMessage('Please set required fields.');
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'SCH', openWorkflowId: instance?.id}));
        // }
    },[open, document]);

    const loadInstanceConfiguration = (inst) => {
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.id) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config); // save original config object so we don't use other configuration
                    const m = config.properties?.schema?.schemaName ? config.properties.schema.schemaName : '';
                    setSchemaValue(m);
                    const s = config.properties?.schema?.schemaLabel ? config.properties.schema.schemaLabel : '';
                    setLabelValue(s);
                    const os = config.properties?.schema?.styleName ? config.properties.schema.styleName : '';
                    setStyleValue(os);
                    
                    computeOkEnable(m, s, os);
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = (name, label, style ) => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        let value = true;
        let message = '';
        if ( !name || name.trim() === '') {
            value = false;
            // console.log('Schema Name is not valid');
            // setErrorMessage('Please set required fields.');
            message = 'Please set required fields.';
        }
        if ( !label || label.trim() === '') {
            value = false;
            // console.log('Label is not valid');
            // setErrorMessage('Please set required fields.');
            message = 'Please set required fields.';
        }
        if ( !style || style.trim() === '') {
            value = false;
            // console.log('Style Name is not valid');
            // setErrorMessage('Please set required fields.');
            message = 'Please set required fields.';
        } 
        if ( value ) {
            // setErrorMessage('');
            message = '';
        }
        //console.log('OK enabled = ' + value);
        setOkEnabled(value);
        setErrorMessage(message);
        return {schemaValid: value, message: message };
    };

    /*
    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = { ...config };
            if ( !vv.properties) {
                vv.properties = {};
            }
            if ( !vv.properties.schema) {
                vv.properties.schema = {};
            }
            vv.properties.schema.schemaName = schemaValue;
            vv.properties.schema.schemaLabel = labelValue;
            vv.properties.schema.styleName = styleValue;
            const schema = schemaList.find( s => s.id === schemaValue);
            if ( schema ) {
                vv.properties.schema.schemaInfo = schema;
            }
            const style = styleList.find( s => s.name === styleValue);
            if ( style ) {
                vv.properties.schema.styleInfo = style;
            }
            onSave(vv, action);
        }
    };
    */

    const schemaChanged = (event) => {
        setSchemaValue(event.target.value);
        const ss = schemaList.find( s => s.id === event.target.value);
        const sty = styleList.find( s => s.name === styleValue);
        const label = ss ? ss.name : '';
        console.log('Schema changed: ' + event.target.value + ' : ' + JSON.stringify(ss));
        setLabelValue(label);
        const status = computeOkEnable(event.target.value, label, styleValue);
        if ( typeof onChange === 'function') {
            const sch= config.properties?.schema ? {...config.properties.schema} : {};
            sch.schemaName = event.target.value;
            sch.schemaLabel = label;
            sch.styleName = styleValue;
            sch.schemaInfo = ss;
            sch.styleInfo = sty;
            sch.status = status;
            onChange(sch);
        }
    };

    const styleChanged = (event) => {
        setStyleValue(event.target.value);
        const sty = styleList.find( s => s.name === event.target.value);
        const ss = schemaList.find( s => s.id === schemaValue);
        const status = computeOkEnable(schemaValue, labelValue, event.target.value);
        if ( typeof onChange === 'function') {
            const sch = config.properties?.schema ? {...config.properties.schema} : {};

            sch.schemaName = schemaValue;
            sch.schemaLabel = labelValue;
            sch.styleName = event.target.value;
            sch.styleInfo = sty;
            sch.schemaInfo = ss;
            sch.status = status;

            onChange(sch);
        }
    };




    return (
        <Box>
            <Box sx={{ paddingTop: 4 }}>

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em', minWidth: '7em' }}>Schema:</Typography>
                    <FormControl sx={{ m: 1, minWidth: '15em', maxWidth: '100%', marginLeft: 0 }} size="small">
                        <Select
                            disabled={readOnly}
                            value={schemaValue}
                            onChange={schemaChanged}
                            sx={{ minWidth: '15em' }}
                            MenuProps={TypeMenuProps}
                        >
                            {schemaList.map(ss =>
                                <MenuItem key={`CDS-${ss.id}`}
                                    value={ss.id}>
                                    {ss.name}
                                </MenuItem>
                            )}

                        </Select>
                    </FormControl>

                </Box>

            </Box>
            <Box sx={{ paddingTop: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em', minWidth: '7em' }}>Style:</Typography>
                    <FormControl sx={{ m: 1, minWidth: '15em', maxWidth: '100%', marginLeft: 0 }} size="small">
                        <Select
                            disabled={readOnly}
                            value={styleValue}
                            onChange={styleChanged}
                            sx={{ minWidth: '15em' }}
                            MenuProps={TypeMenuProps}
                        >
                            {styleList.map(ss =>
                                <MenuItem key={`CDSS-${ss.name}`}
                                    value={ss.name}>
                                    {ss.name}
                                </MenuItem>
                            )}

                        </Select>
                    </FormControl>

                </Box>
            </Box>

        </Box>

    );

}

function DocumentEffectivityChooserDialog (props) {
    const {
        title = 'Select Document Effectivity',
        namespace = 'NZ_AIRCRAFT',
        instance=null, // workflow instance containing reference to document
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [sizes, setSizes] = useState(['40%', '60%', 'auto']);
    const [okEnabled, setOkEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [docModel, setDocModel] = useState([]);
    const [docItems, setDocItems] = useState([]); // selected items
    const [docExpandedItems, setDocExpandedItems] = useState([]);
    const [docItemIdMap, setDocItemIdMap] = useState({});
    const [effNamespace, setEffNamespace] = useState('NZ_AIRCRAFT');
    const [effModel, setEffModel] = useState([]);
    const [effModelIdMap, setEffModelIdMap] = useState({});
    const [effModelLabelMap, setEffModelLabelMap] = useState({});
    const [effItems, setEffItems] = useState([]);

    useEffect( () => {
        if ( open ) {
            setDocItems([]);
            setEffItems([]);
        }

    },[open]);

    useEffect( () => {
        // console.log('document = ' + JSON.stringify(document));
        if ( instance ) {
            // fallback
            const docmap = {};
            const docid = instance.id ? instance.id: 'doc-0';
            docmap[docid] = {
                id: docid,
                label: instance.name,
            };
            setDocItemIdMap(docmap);
            loadDocument(docid);
            setDocModel([{id: docid, xid: docid, label: instance.name, entry: {}, root: true}]);
            setDocItems([]);
            setEffItems([]);
        }
    },[instance]);

    const loadDocument = (doc) => {
        const url = '/api/doc/tree/' + encodeURIComponent(doc);
        netGet(url)
            .then(response => response.json())
            .then(droot => {
                if (droot) {
                    // change root id to match doc id (legacy compat), default is XML id
                    
                    droot.xid = droot.entry?.id;
                    droot.id = doc;
                    // console.log('TREE: ' + JSON.stringify(droot));
                    if ( droot.namespace ) {
                        setEffNamespace(droot.namespace);
                    } else {
                        setEffNamespace(namespace);
                    }
                    setDocModel([droot]);
                    setDocExpandedItems([droot.id]);
                    setDocItems([]);
                    const docmap = {};
                    loadDocMap(droot, docmap);
                    setDocItemIdMap(docmap);
                } 
            }).catch(error => {
                console.log('Error fetching Document tree: ' + error);
            });
    };

    const loadDocMap = (node, docmap) => {
        docmap[node.id] = node;
        if( Array.isArray(node.children) ) {
            node.children.forEach( child => loadDocMap(child, docmap));
        }
    };

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const eff = resolveEff();
            console.log('RESOLVED EFF: ' + JSON.stringify(eff));
            onSave(eff);
        }
    }

    const getAncestorLabels = (label) => {
        const alist = [];
        if ( label ) {
            let p = effModelLabelMap[label];
            while ( p ) {
                alist.push(p.label);
                if ( p.parentLabel ) {
                    p = effModelLabelMap[p.parentLabel];
                } else {
                    break;
                }
            }
        }
        return alist;
    };

    // we need to create nodes and attach them to closest ancestor within the selection, 
    // so at the end we only return the root nodes (those without parent within the set)
    const resolveEff = () => {
        const titems = effItems.map( id => {
            const item = effModelIdMap[id];
            if ( item ) {
                return {
                    key: item.id,
                    data: {
                        item: {
                          type: item.type,
                          id: item.id,
                          seq: item.seq ? item.seq : -1,
                          label: item.label,
                          parentLabel: item.parentLabel,
                          ancestorLabels: getAncestorLabels(item.parentLabel),
                          name: item.name,
                          group: item.group,
                          stmt: item.stmt,
                          eff: item.eff,  
                        },
                        color: '#000',
                        ename: item.name,
                        elabel: item.label,
                        eparent: item.parentLabel,
                    },
                    children: [],
                };
            }
            return { key: id, data: { elabel: '', eparent: ''}, children: []};
        }).sort((a,b) => a.data.item.seq - b.data.item.seq);
        const ditems = docItems.map( id => {
            const item = docItemIdMap[id];
            if ( item ) {
                const ditem = {
                    key: item.id,
                    data: {
                        doc: { ...item},
                        elabel: item.label,
                    }
                };
                // ditem.data.doc.xid = item.entry?.id;
                ditem.data.doc.entry = undefined;
                ditem.data.doc.children = undefined;
                ditem.data.doc.code = item.entry?.code;
                ditem.data.doc.eid = item.entry?.entryId;
                
                return ditem;
            }
            return {key: id, data: {}};
        })
        const roots = [];
        for(let i=0; i<titems.length; i++) {
            let item = titems[i];
            if ( !item.data?.eparent || item.data?.eparent === '') {
                roots.push(item);
            } else {
                let p = effModelLabelMap[item.data.eparent];
                if ( p ) {
                    let pitem = titems.find( pi => pi.key === p.id );
                    while ( !pitem ) {
                        p = effModelLabelMap[p.parentLabel];
                        if ( !p ) {
                            break;
                        }
                        pitem = titems.find( pi => pi.data.item.id === p.id );
                    }
                    if ( pitem ) {
                        // found the ancestor, attach it there
                        pitem.children.push(item);
                    } else {
                        roots.push(item);
                    }
                } else {
                    roots.push(item);
                }
            }
        }
        // roots should contain our targets, now we need to multiply by the number of docs
        const res = [];
        ditems.forEach( d => {
            roots.forEach( r => {
                const rr = cloneRoot(r);
                addDoc(rr, d);
                res.push(rr);
            });
        });
        return res;
    };

    const addDoc = (r , d, p) => {
        r.key = d.data.doc.id + '-' + r.data.item.id;
        r.data.dlabel = d.data.elabel;
        r.data.doc = d.data.doc;
        r.data.pkey = p; // parent key
        r.children.forEach( c => {
            addDoc(c, d, r.key);
        });
    };

    const cloneRoot = (r) => {
        const rr = { ...r};
        rr.children = [];
        r.children.forEach( c => {
            const cc = cloneRoot(c);
            rr.children.push(cc);
        })
        return rr;
    };

    const loadModelMap = (model, idmap, labelmap) => {
        if (Array.isArray(model) && model.length > 0 ) {
            model.forEach(item => {
                idmap[item.id] = item;
                labelmap[item.label] = item;
                loadModelMap(item.children, idmap, labelmap);
            });
        }
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const handleDocItemsChange = (event, ids) => {
        setDocItems(ids);
        computeOkEnable(ids, effItems);
    };

    const handleEffItemsChange = (event, ids) => {
        setEffItems(ids);
        computeOkEnable(docItems, ids);
    };

    const handleEffModelChange = (model) => {
        setEffModel(model);
        const idmap = {};
        const labelmap = {};
        loadModelMap(model, idmap, labelmap);
        setEffModelIdMap(idmap);
        setEffModelLabelMap(labelmap);
    }

    const computeOkEnable = (ditems, eitems) => {
        // console.log('Selected: ' + JSON.stringify(ditems) + ' : ' + JSON.stringify(eitems));
        setOkEnabled(Array.isArray(ditems) && ditems.length > 0 && Array.isArray(eitems) && eitems.length > 0);
    }

    const displayDocNode = (item) => {
        /*
        <SimpleTreeView
            selectedItems={docItems}
            onSelectedItemsChange={handleDocItemsChange}
            // onItemClick={handleItemClick}
            multiSelect
            >
            {instance &&
                <TreeItem itemId={instance.properties?.document ? instance.properties.document : 'doc-0'} label={instance.label} />
            }
            </SimpleTreeView>
        */
        const prefix = item.entry?.mid !== 'VOLUME' && item.entry?.code && item.entry?.code !== '' && item.entry?.code !== '-' ? item.entry.code + ' ' : '';
        return (<TreeItem itemId={item.id} label={prefix + item.label}>
            {Array.isArray(item.children) && item.children.length > 0 &&
                item.children.map(child => displayDocNode(child))
            }
        </TreeItem>);
    };

    const handleItemClick = (event, itemId) => {
        /*
        if ( itemId === selectedItems ) {
            setSelectedItems(null);
            setOkEnabled(false);
            setSelectedNode(null);
        } else {
            const item = findItem(model, itemId);
            if ( item?.entry.type === 'DU' ) {
                setSelectedItems(itemId);
                setOkEnabled(true);
                setSelectedNode(item);
            } else {
                setSelectedItems(null);
                setSelectedNode(null);
                setOkEnabled(false);
            }
        }
        */
    }

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { 
                    sx: {
                        minWidth: 800,
                        maxWidth: 900,
                        maxHeight: 750,
                        minHeight: 700,
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{ height: '550px' }}>
                    <SplitPane
                        split='vertical'
                        sizes={sizes}
                        onChange={setSizes}
                    >
                        <Pane minSize='40%' maxSize='50%'>
                            <Box>
                                <Typography sx={{fontSize: '110%', fontWeight: 'bold'}}>Document</Typography>
                                
                                <SimpleTreeView
                                    selectedItems={docItems}
                                    
                                    onSelectedItemsChange={handleDocItemsChange}
                                    expansionTrigger="iconContainer"
                                    expandedItems={docExpandedItems}
                                    onExpandedItemsChange={(event, itemids) => setDocExpandedItems(itemids)}
                                    multiSelect
                                >
                                    {Array.isArray(docModel) && docModel.length > 0 &&
                                        docModel.map(item => displayDocNode(item))
                                    }
                                </SimpleTreeView>
                            </Box>
                        </Pane>
                        <Box sx={{height: '100%'}}>
                            <Typography sx={{fontSize: '110%', fontWeight: 'bold'}}>Effectivity</Typography>
                            <Box sx={{height: '90%', overflow: 'auto'}}>
                                <EffectivityChooser namespace={effNamespace} onSelectedItemsChange={handleEffItemsChange} onModelChange={handleEffModelChange} />
                            </Box>
                        </Box>
                    </SplitPane>
                </Box>
                
            </DialogContent>
            <DialogActions sx={{padding: 3, display: 'flex', justifyContent: 'space-between'}}>
                <Typography color="warning">{errorMessage}</Typography>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );
}

function EffectivityChooserDialog (props) {
    const {
        title = 'Select Effectivity',
        namespace = 'NZ_AIRCRAFT',
        instance=null, // workflow instance containing reference to document
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [sizes, setSizes] = useState(['40%', '60%', 'auto']);
    const [okEnabled, setOkEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [docModel, setDocModel] = useState([]);
    const [docItems, setDocItems] = useState([]); // selected items
    const [effNamespace, setEffNamespace] = useState('NZ_AIRCRAFT');
    const [effModel, setEffModel] = useState([]);
    const [effModelIdMap, setEffModelIdMap] = useState({});
    const [effModelLabelMap, setEffModelLabelMap] = useState({});
    const [effItems, setEffItems] = useState([]);

    useEffect( () => {
        if ( open ) {
            setEffItems([]);
        }

    },[open]);

    useEffect( () => {
        // console.log('document = ' + JSON.stringify(document));
        if ( instance ) {
            // fallback
            const docmap = {};
            // const docid = instance.properties?.document ? instance.properties.document : 'doc-0';
            const docid = instance.id ? instance.id : 'doc-0';
            docmap[docid] = {
                id: docid,
                label: instance.name,
            };
            // setDocItemIdMap(docmap);
            // loadDocument(docid);
        }
    },[instance]);

    

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const eff = resolveEff();
            console.log('RESOLVED EFF: ' + JSON.stringify(eff));
            onSave(eff);
        }
    }

    const getAncestorLabels = (label) => {
        const alist = [];
        if ( label ) {
            let p = effModelLabelMap[label];
            while ( p ) {
                alist.push(p.label);
                if ( p.parentLabel ) {
                    p = effModelLabelMap[p.parentLabel];
                } else {
                    break;
                }
            }
        }
        return alist;
    };

    // we need to create nodes and attach them to closest ancestor within the selection, 
    // so at the end we only return the root nodes (those without parent within the set)
    const resolveEff = () => {
        const titems = effItems.map( id => {
            const item = effModelIdMap[id];
            if ( item ) {
                return {
                    key: item.id,
                    data: {
                        item: {
                          type: item.type,
                          id: item.id,
                          seq: item.seq ? item.seq : -1,
                          label: item.label,
                          parentLabel: item.parentLabel,
                          ancestorLabels: getAncestorLabels(item.parentLabel),
                          name: item.name,
                          group: item.group,
                          stmt: item.stmt,
                          eff: item.eff,  
                        },
                        color: '#000',
                        ename: item.name,
                        elabel: item.label,
                        eparent: item.parentLabel,
                    },
                    children: [],
                };
            }
            return { key: id, data: { elabel: '', eparent: ''}, children: []};
        }).sort((a,b) => a.data.item.seq - b.data.item.seq);
        
        const roots = [];
        for(let i=0; i<titems.length; i++) {
            let item = titems[i];
            if ( !item.data?.eparent || item.data?.eparent === '') {
                roots.push(item);
            } else {
                let p = effModelLabelMap[item.data.eparent];
                if ( p ) {
                    let pitem = titems.find( pi => pi.key === p.id );
                    while ( !pitem ) {
                        p = effModelLabelMap[p.parentLabel];
                        if ( !p ) {
                            break;
                        }
                        pitem = titems.find( pi => pi.data.item.id === p.id );
                    }
                    if ( pitem ) {
                        // found the ancestor, attach it there
                        pitem.children.push(item);
                    } else {
                        roots.push(item);
                    }
                } else {
                    roots.push(item);
                }
            }
        }
        // roots should contain our targets, now we need to multiply by the number of docs
        const res = [];
        roots.forEach(r => {
            const rr = cloneRoot(r);

            res.push(rr);
        });
        
        return res;
    };

    const cloneRoot = (r) => {
        const rr = { ...r};
        rr.children = [];
        r.children.forEach( c => {
            const cc = cloneRoot(c);
            rr.children.push(cc);
        })
        return rr;
    };

    const loadModelMap = (model, idmap, labelmap) => {
        if (Array.isArray(model) && model.length > 0 ) {
            model.forEach(item => {
                idmap[item.id] = item;
                labelmap[item.label] = item;
                loadModelMap(item.children, idmap, labelmap);
            });
        }
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };


    const handleEffItemsChange = (event, ids) => {
        setEffItems(ids);
        computeOkEnable(docItems, ids);
    };

    const handleEffModelChange = (model) => {
        setEffModel(model);
        const idmap = {};
        const labelmap = {};
        loadModelMap(model, idmap, labelmap);
        setEffModelIdMap(idmap);
        setEffModelLabelMap(labelmap);
    }

    const computeOkEnable = (ditems, eitems) => {
        // console.log('Selected: ' + JSON.stringify(ditems) + ' : ' + JSON.stringify(eitems));
        setOkEnabled(Array.isArray(eitems) && eitems.length > 0);
    }


    const handleItemClick = (event, itemId) => {
        /*
        if ( itemId === selectedItems ) {
            setSelectedItems(null);
            setOkEnabled(false);
            setSelectedNode(null);
        } else {
            const item = findItem(model, itemId);
            if ( item?.entry.type === 'DU' ) {
                setSelectedItems(itemId);
                setOkEnabled(true);
                setSelectedNode(item);
            } else {
                setSelectedItems(null);
                setSelectedNode(null);
                setOkEnabled(false);
            }
        }
        */
    }

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { 
                    sx: {
                        minWidth: 800,
                        maxWidth: 900,
                        maxHeight: 750,
                        minHeight: 700,
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{ height: '550px' }}>

                    <Box sx={{ height: '100%' }}>
                        <Typography sx={{ fontSize: '110%', fontWeight: 'bold' }}>Effectivity</Typography>
                        <Box sx={{ height: '90%', overflow: 'auto' }}>
                            <EffectivityChooser namespace={effNamespace} onSelectedItemsChange={handleEffItemsChange} onModelChange={handleEffModelChange} />
                        </Box>
                    </Box>

                </Box>
                
            </DialogContent>
            <DialogActions sx={{padding: 3, display: 'flex', justifyContent: 'space-between'}}>
                <Typography color="warning">{errorMessage}</Typography>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );
}

function EditTitleDialog ( props ) {
    const {
        title = 'Change Node Label',
        open,
        value,
        onSave,
        onCancel,
        ...other

    } = props;

    const [titleValue, setTitleValue] = useState('');
    const [okEnabled, setOkEnabled] = useState(true);

    useEffect( () => {
        setTitleValue(value);
    },[value]);

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {  
            onSave(titleValue);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const onTitleChange = (event) => {
        setTitleValue(event.target.value);
    };

    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { 
                    sx: {
                        minWidth: 700,
                        maxWidth: 800,
                        maxHeight: 550,
                        minHeight: 500,
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent sx={{paddingTop: 3}}>
                <TextField label="Node Label" fullWidth value={titleValue} onChange={onTitleChange} size="small" sx={{marginTop: 5}}/>
            </DialogContent>
            <DialogActions sx={{padding: 3, paddingTop: 1, }}>
                <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
            </DialogActions>
            </Dialog>
    );
}



function CreateDocumentEffectivityDialog(props) {
    const {
        title = 'Create Document—Effectivity',
        instance = null,
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [effNodes, setEffNodes] = useState([]); // Effectivity Config entries
    const [effList, setEffList] = useState([]); // same as effNodes but items are flatten into a list
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null);
    const [colorNode, setColorNode] = useState(null); // focused node, may not be the selected
    const [expandedKeys, setExpandedKeys] = useState({});

    const [config, setConfig] = useState(null); // DLib config id (Long)
    const [operator, setOperator] = useState('');
    const [okEnabled, setOkEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [moveupEnabled, setMoveupEnabled] = useState(false);
    const [movedownEnabled, setMovedownEnabled] = useState(false);
    const [moveoutEnabled, setMoveoutEnabled] = useState(false);

    const [effDialogOpen, setEffDialogOpen] = useState(false);
    const [colorDialogOpen, setColorDialogOpen] = useState(false);
    const [colorDialogValue, setColorDialogValue] = useState('#000');

    const [titleDialogOpen, setTitleDialogOpen] = useState(false);
    const [titleDialogValue, setTitleDialogValue] = useState('');
    const [titleDialogNode, setTitleDialogNode] = useState(null);
    
    const dispatch = useDispatch();

    const CELL_PADDING = '0.8ex';
    const COLOR_MY_LOCK = 'green';
    const COLOR_OTHER_LOCK = '#cc0000';
    const COLOR_CHILD_LOCK = '#e0d910'; // '#e6df19';
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };


    useEffect( () => {
        netGet('/config/realm')
            .then(response => response.json())
            .then(rinfo => {
                if ( rinfo?.realm ) {
                    setOperator(rinfo.realm);
                }
            }).catch ( error => {
                console.log('Error fetching realm name: ' + error);
            });
    },[]);

    useEffect( () => {
        if ( open && instance ) {
            
            setErrorMessage('');
            loadInstanceConfiguration(instance);
            setSelectedNode(null);
            setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setOkEnabled(false);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
        } else {
            setEffNodes([]);
            setConfig(null);
            setErrorMessage('Please set required fields');
            setOkEnabled(false);
            setSelectedNode(null);
            setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'GEN', openWorkflowId: instance?.id}));
        // }

    },[open, instance]);

    const loadInstanceConfiguration = (inst) => {
        setEffNodes([]);
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.properties?.document) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config);
                    let nodes = config.properties?.eff?.source ? config.properties.eff.source : [];
                    if ( !Array.isArray(nodes) ) {
                        nodes = [];
                    }
                    const elist = [];
                    flattenTree(elist, nodes);
                    setEffNodes(nodes);
                    setEffList(elist);
                    setOkEnabled(false);
                    /*
                    const m = config.properties?.general?.model ? config.properties.general.model : '';
                    setTypeValue(m);
                    const om = config.properties?.general?.otherModel ? config.properties.general.otherModel : '';
                    setOtherValue(om);
                    const s = config.properties?.general?.shortName ? config.properties.general.shortName : '';
                    setShortNameValue(s);
                    const os = config.properties?.general?.otherShortName ? config.properties.general.otherShortName : '';
                    setOtherShortValue(os);
                    if ( config.description ) {
                        setDescriptionValue(config.description);
                    }
                    let n = config.properties?.general?.displayName ? config.properties?.general?.displayName : inst.properties?.instanceName;
                    if ( !n ) {
                        n = '';
                    }
                    computeOkEnable(inst.properties?.document, n, m, om, s, os);
                    */
                   
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = () => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        
        // console.log('OK enabled = ' + value);
        setOkEnabled(true);
    };


    /*
    React.useEffect(() => {
        

    }, []);
    */

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = { ...config };
            if ( !vv.name ) {
                vv.name = instance?.properties?.document;
            }
            if ( !vv.properties) {
                vv.properties = {};
            }
            if ( !vv.properties.eff) {
                vv.properties.eff = {};
            }
            vv.properties.eff.source = [...effNodes];            
            onSave(vv, action);
        }
    }

    const onNextClick = () => {
        onOKClick('NEXT');
    };

    const onPreviousClick = () => {
        const action = okEnabled ? 'PREV_OK' : 'PREV_CANCEL';
        onOKClick(action);
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const handleAddAction = () => {
        setEffDialogOpen(true);
        // clear selection so we don't get funnies
        setSelectedNodeKey({});
        setSelectedNode(null);
        setDeleteEnabled(false);
        setMoveupEnabled(false);
        setMovedownEnabled(false);
    };

    const handleSelectedNodeKey = (event) => {
        console.log('Selected Node key: ' + JSON.stringify(event?.value) );
        // console.log('Selected Node other: ' + JSON.stringify(other) );
        if (event.value) {
            setSelectedNodeKey(event.value);
            // console.log('Selected node keys: ' + JSON.stringify(Object.keys(event.value)));
            if (typeof event.value === 'string') {
                const sn = effList.find(n => n.key === event.value);
                setSelectedNode(sn);
                // setCurrentNode(sn);
                if (sn) {
                    setDeleteEnabled(true);
                } else {
                    setDeleteEnabled(false);
                }
                const si = effList.findIndex(n => n.key === event.value);
                setMoveupEnabled(si > 0);
                setMovedownEnabled(si >= 0 && si < effList.length - 1);
            } else {
                let sn = null;
                let skey = null;
                const size = Object.keys(event.value).length;
                for(let key in event.value) {
                    if ( typeof event.value[key] === 'boolean' && event.value[key] ) {
                        sn = effList.find(n => n.key === key);
                        // size++;
                        skey = key;
                        if ( sn ) {
                            break;
                        }
                    }
                }
                if ( sn ) {
                    setDeleteEnabled(true);
                    setSelectedNode(sn);
                } else {
                    setDeleteEnabled(false);
                    setSelectedNode(null);
                }
                if ( size === 1 ) {
                    // console.log('Finding key: ' + skey);
                    const si = effList.findIndex(n => n.key === skey);
                    if ( si >= 0 ) {
                        const sn = effList[si];
                        setMoveupEnabled(si > 0);
                        setMovedownEnabled(si < effList.length - 1);
                        setMoveoutEnabled(typeof sn?.data?.kparent === 'string' && !sn.data.kparent.length > 0);
                    }
                } else {
                    // console.log('MULTIPLE');
                    setMoveupEnabled(false);
                    setMovedownEnabled(false);
                    setMoveoutEnabled(false);
                    // setSelectedNodeKey({});
                }
            }
        } else {
            setSelectedNodeKey(null);
            // setCurrentNode(null);
            setSelectedNode(null);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
            setMoveoutEnabled(false);
        }
    };

    const handleSelectedNode = (event) => {
        console.log('Selected Node: ' + JSON.stringify(event.node?.key) );
        setSelectedNode(event.node);
        /*
        const keys = {};
        if ( event.node?.key ) {
            keys[event.node.key] = true;
        }
        setSelectedNodeKey(keys);
        */
        // setCurrentNode(event.node);
    };

    const handleToggleNode = (event) => {
        setExpandedKeys(event.value);
    };

    const toggleNode = (node) => {
        let xkeys = expandedKeys ? { ...expandedKeys } : {};
        if (xkeys[node.key]) {
            delete xkeys[node.key];
        } else {
            xkeys[node.key] = true;
        }
        setExpandedKeys(xkeys);
    };

    const flattenTree = ( list, tree ) => {
        if (Array.isArray(tree) ) {
            tree.forEach( t => {
                list.push(t);
                if ( Array.isArray(t.children) ) {
                    flattenTree(list, t.children);
                }
            });
        }
    };

    const docTemplate = (node, options) => {
        let label = node?.data?.dlabel;
        let prefix = node?.data?.doc?.root ? '' : node?.data?.doc?.code + ' ';
        if ( !prefix || prefix === '-' ) {
            prefix = '';
        }
        
        const i = effList.findIndex( n => n.key === node.key );
        /*
        const en = effNodes.map(n => n.key);
        console.log('Current nodes = ' + JSON.stringify(en));
        console.log('My index = ' + i + ' key = ' + node.key);
        */
        if ( i > 0 ) {
            const prev = effList[i-1];
            if ( prev?.data?.dlabel === label ) {
                label = '';
                prefix = '';
            }
        }
        return (
            <Typography>{prefix + label}</Typography>
        );
    };

    const handleColorClick = (node) => {
        setColorDialogOpen(true);
        const c = node?.data?.color  ? node.data.color : '#000';
        setColorNode(node);
        setColorDialogValue(c);
    };

    const handleColorSave = (color) => {
        setColorDialogOpen(false);
        // console.log('Color = ' + JSON.stringify(color));
        
        if ( colorNode ) {
            const ee = [...effNodes];
            const elist = [];
            flattenTree(elist, ee);
            const cn = elist.find( n => n.key === colorNode.key);
            // console.log('Selected color node = ' + JSON.stringify(cn));
            if ( cn ) {
                cn.data.color = color;
                setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
            }
        } else {
            console.log('No current node!');
        }
    };

    const labelTemplate = (node, options) => {
        /*
        return (
            <Button variant="text" onClick={() => toggleNode(node)} 
            sx={{ color: 'rgba(0,0,0,0.87)', textAlign: 'left', minWidth: '7em', justifyContent: 'flex-start', textTransform: 'none' }}>{node?.data?.ename}</Button>
        );
        */
       return (
        <Typography>{node.data?.ename}</Typography>
       )
    };

    const getSelectable = (node) => {
        if ( node ) {
            if ( typeof node.data.select === 'boolean' ) {
                return node.data.select;
            } 
        }
        return true;
    }

    const onSelectableChange = (node, event) => {
        console.log('Selectable: ' + node.key + ' ' + event.target.checked);
        if ( node ) {
            const ee = [...effNodes];
            const elist = [];
            flattenTree(elist, ee);
            const cn = elist.find( n => n.key === node.key);
            // console.log('Selected color node = ' + JSON.stringify(cn));
            if ( cn ) {
                cn.data.select = event.target.checked;
                setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
            }
        }

    }

    const selectableTemplate = (node, options) => {
        return (
            <Checkbox checked={getSelectable(node)} onChange={(event) => onSelectableChange(node, event)} />
        );
    };

    const handleTitleClick = (node) => {
        setTitleDialogNode(node);
        setTitleDialogValue(node.data?.title ? node.data.title : node.data?.ename);
        setTitleDialogOpen(true);

    };

    const handleTitleDialogSave = (value) => {
        setTitleDialogOpen(false);
        const node = titleDialogNode;
        if (node) {
            if (node) {
                node.data.title = value;
                setOkEnabled(true);
            }
        }
    }

    const titleTemplate = (node, options) => {
        return (
            <Button variant="text" onClick={() => handleTitleClick(node)} 
                sx={{textAlign: 'left', padding: 0, justifyContent: 'start', color: 'inherit', textTransform: 'none'}}
                >{node.data?.title ? node.data.title : node.data?.ename}</Button>
        );
    };

    const colorTemplate = (node, options) => {
        const color = node?.data?.color  ? node.data.color : '#000';
        return (
            <IconButton onClick={() => handleColorClick(node)}>
                <Brightness1Icon fontSize="small" sx={{color: color}} />
            </IconButton>
        );
    };

    const loadLabelMap = (model, labelmap) => {
        if (Array.isArray(model) && model.length > 0 ) {
            model.forEach(item => {
                labelmap[item.data.elabel] = item;
                loadLabelMap(item.children, labelmap);
            });
        }
    };

    const findNode = (root, node) => {
        if ( root.key === node.key ) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNode(c, node);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    };

    const findNodeByLabel = (root, label) => {
        if ( root.data.elabel === label) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNodeByLabel(c, label);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    }

    const isDescendant = (root, node) => {
        if ( Array.isArray(node.data?.item?.ancestorLabels) ) {
            for(let i=0; i<node.data.item.ancestorLabels.length; i++) {
                const label = node.data.item.ancestorLabels[i];
                if ( root.data.elabel === label ) {
                    return true;
                }
            }
        }
        return false;
    };

    const mergeNode = (root, node) => {
        const tn = findNode(root, node);
        if ( tn ) { // already in tree
            if ( Array.isArray(node.children) && node.children.length > 0 ) {
                for(let i=0; i<node.children.length; i++) {
                    const tc = node.children[i];
                    mergeNode(tn, tc);
                }
            }
            // node already matched, even if no further merging down the descendants
            return true; 
            
        } else {
            if ( Array.isArray(node.data?.item?.ancestorLabels) ) {
                for(let i=0; i< node.data.item.ancestorLabels.length; i++) {
                    const label = node.data.item.ancestorLabels[i];
                    
                    const ln = findNodeByLabel(root, label);
                    // console.log('Test label = ' + label + ' : ' + ln);
                    if ( ln ) {
                        // found and ancestor, insert it
                        const nchildren = [];
                        if ( !Array.isArray(node.children) ) {
                            node.children = [];
                        }
                        if ( Array.isArray(ln.children) ) {
                            ln.children.forEach( c => {
                                if ( isDescendant(node, c) ) {
                                    c.data.pkey = node.key;
                                    node.children.push(c);
                                } else {
                                    c.data.pkey = ln.key;
                                    nchildren.push(c);
                                }
                            });
                        }
                        nchildren.push(node);
                        node.children.sort( (a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        nchildren.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        ln.children = nchildren;
                        return true;
                    }
                }
            }
        }
        return false;
    };

    const addNodes = (enodes, nodes) => {
        if ( Array.isArray(nodes) ) {
            nodes.forEach( n => {
                let m = false;
                for(let i=0; i<enodes.length; i++) {
                    const tn = enodes[i];
                    if ( tn.data?.doc?.id === n.data?.doc?.id) {
                        m = mergeNode(tn, n);
                        if ( m ) {
                            break;
                        }
                    }
                }
                if ( !m ) {
                    enodes.push(n);
                    // console.log('NOT MERGED: ' + JSON.stringify(n) );
                    // console.log('EFF NODES: ' + JSON.stringify(ee));
                }
            });
            enodes.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);            
        }
    };

    const handleEffSave = (nodes) => {
        setEffDialogOpen(false);
        const ee = [...effNodes];
        // simply append nodes, let admin organize as desired, including removing duplicates
        nodes.forEach ( n => ee.push(n));
        const elist = [];
        flattenTree(elist, ee);
        setEffList(elist);
        setEffNodes(ee);
        setOkEnabled(true);
    };

    const handleEffSaveOld = (nodes) => {
        setEffDialogOpen(false);
        // console.log('New Tree Nodes: ' + JSON.stringify(nodes.map(n => n.key)));
        // console.log('New Tree Nodes: ' + JSON.stringify(nodes));
        const ee = [...effNodes];
        
        addNodes(ee, nodes);

        // do a second pass collecting nodes that may belong inside other others
        const rns = []; // nodes to remove and merge elsewhere
        for(let i=0; i<ee.length; i++) {
            const ni = ee[i];
            for(let j=0; j<ee.length; j++) {
                if ( i !== j ) {
                    const nj = ee[j];
                    if ( Array.isArray(nj.data.item.ancestorLabels) ) {
                        for(let k=0; k<nj.data.item.ancestorLabels.length; k++) {
                            const label = nj.data.item.ancestorLabels[k];
                            if ( ni.data.elabel === label ) {
                                rns.push(nj);
                                break;
                            }
                        }
                    }
                }
            }
        }
        if ( rns.length > 0 ) {
            rns.forEach( n => {
                const ri = ee.findIndex( m => m.key === n.key);
                if ( ri >= 0 ) {
                    ee.splice(ri, 1);
                }
            });
            addNodes(ee, rns);
        }
        ee.sort( (a,b) => a.data?.doc?.seq - b.data?.doc?.seq);
        // console.log('New Eff Nodes: ' + JSON.stringify(ee));
        const elist = [];
        flattenTree(elist, ee);
        setEffList(elist);
        setEffNodes(ee);
        setOkEnabled(true);
    }

    const deleteNode = (enodes, key) => {
        const elist = [];
        flattenTree(elist, enodes);
        const dn = elist.find(n => n.key === key);
        if (dn) {
            const pn = dn.data?.pkey ? elist.find(n => n.key === dn.data?.pkey) : null;
            if (pn) {
                // remove from internal node
                const i = Array.isArray(pn.children) ? pn.children.findIndex(n => n.key === dn.key) : -1;
                if (i >= 0) {
                    pn.children.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            pn.children.push(c);
                            c.data.pkey = pn.key;
                        });
                        pn.children.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }

                }
            } else {
                // remove from effNodes
                const i = enodes.findIndex(n => n.key === dn.key);
                if (i >= 0) {
                    enodes.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            enodes.push(c);
                            c.data.pkey = null;
                        });
                        enodes.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }
                }
            }
            // elist.splice(0, elist.length);
            //flattenTree(elist, enodes);
            // setEffNodes(enodes);
            // setEffList(elist);
        }
    };

    const handleDeleteAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                deleteNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key] ) {
                        deleteNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
        }
    };

    const handleMoveupAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                moveUpNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key]) {
                        moveUpNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
        }
    };

    const moveUpNode = (enodes, key) => {
        // only move top nodes
        const i = enodes.findIndex(n => n.key === key);
        console.log('Node index = ' + i);
        if ( i > 0 ) {
            const node = enodes[i];
            const pnode = enodes[i-1];
            enodes[i] = pnode;
            enodes[i-1] = node;
        }

    };

    const handleMovedownAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                moveDownNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key]) {
                        moveDownNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
        }
    };

    const moveDownNode = (enodes, key) => {
        // only move top nodes
        const i = enodes.findIndex(n => n.key === key);
        if ( i < enodes.length - 1 ) {
            const node = enodes[i];
            const fnode = enodes[i+1];
            enodes[i+1] = node;
            enodes[i] = fnode;
        }

    };

    const handleMoveinAction = () => {
        // move in (indent right) under previous node that is one level down
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                moveUpNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key]) {
                        moveInNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
        }

    };

    const moveInNode = (enodes, key) => {
        // only move top nodes
        const i = enodes.findIndex(n => n.key === key);
        console.log('Node IN index = ' + i);
        if ( i > 0 ) {
            const node = enodes[i];
            const pnode = enodes[i-1];
            enodes.splice(i, 1);
            if ( !Array.isArray(pnode.children) ) {
                pnode.children = [];
            }
            pnode.children.push(node);
            /*
            const pnode = enodes[i-1];
            enodes[i] = pnode;
            enodes[i-1] = node;
            */
        }

    };

    const handleMoveoutAction = () => {
        // move out (indent left) of current parent on level up

    };

    const handleDeleteAction2 = () => {
        if ( selectedNodeKey ) {
            const enodes = [...effNodes];
            let elist = [];
            flattenTree(elist, enodes);
            const dn = elist.find( n => n.key === selectedNodeKey);
            if ( dn ) {
                const pn = dn.data?.pkey ? elist.find( n => n.key === dn.data?.pkey) : null;
                if ( pn ) {
                    // remove from internal node
                    const i = Array.isArray(pn.children) ? pn.children.findIndex( n => n.key === dn.key) : -1;
                    if ( i >= 0 ) {
                        pn.children.splice(i, 1);
                        if ( Array.isArray(dn.children) && dn.children.length > 0 ) {
                            dn.children.forEach( c => {
                                pn.children.push(c);
                                c.data.pkey = pn.key;
                            });
                            pn.children.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        }
                        
                    }
                } else {
                    // remove from effNodes
                    const i = enodes.findIndex( n => n.key === dn.key);
                    if ( i >= 0 ) {
                        enodes.splice(i, 1);
                        if ( Array.isArray(dn.children) && dn.children.length > 0 ) {
                            dn.children.forEach( c => {
                                enodes.push(c);
                                c.data.pkey = null;
                            });
                            enodes.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        }
                    }
                }
                elist = [];
                flattenTree(elist, enodes);
                setEffNodes(enodes);
                setEffList(elist);
            }
        }
    };
    

    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { 
                    sx: {
                        minWidth: 900,
                        maxWidth: 1100,
                        maxHeight: 750,
                        minHeight: 700,
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>

                <Box sx={{display: 'flex', paddingTop: '2ex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="outlined" onClick={onPreviousClick} sx={{minWidth: '9.5em'}} startIcon={<ArrowBackIosIcon/>}>Previous</Button>
                    <Button variant="outlined" onClick={onNextClick} sx={{minWidth: '9.5em'}} disabled={!okEnabled} endIcon={<ArrowForwardIosIcon/>}>Next</Button>
                </Box>

                <Box sx={{ overflow: 'hidden', paddingTop: '2em', height: '460px' }}>
                    <TreeTable value={effNodes} tableStyle={{ width: '100%',  }} emptyMessage={<span></span>}

                        selectionKeys={selectedNodeKey} expandedKeys={expandedKeys} onToggle={handleToggleNode}
                        selectionMode="multiple" onSelectionChange={handleSelectedNodeKey} onSelect={handleSelectedNode} metaKeySelection={true}
                        scrollable scrollHeight="390px" overflow="auto"
                        defaultSortOrder={0} rowHover >

                        <Column body={docTemplate} header="Document Part" align="left" 
                            headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'left', width: '20%'}} 
                            bodyStyle={{ padding: CELL_PADDING, textAlign: 'left', width: "20%" }} ></Column>

                        <Column field="ename" header="Effectivity" align="left" alignHeader="left" style={{ padding: 0, paddingLeft: '1ex', textAlign: 'left', width: '35%' }}
                            headerStyle={{ padding: '0.9ex', width: '35%', fontSize: '90%', textAlign: 'left' }}
                            bodyStyle={{ textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '35%', padding: CELL_PADDING, }}
                            expander ></Column>

                        <Column body={titleTemplate} header="Node Label" align="left" alignHeader="left" style={{ padding: 0, paddingLeft: '1ex', textAlign: 'left', width: '25%' }}
                            headerStyle={{ padding: '0.9ex', paddingLeft: 0, width: '25%', fontSize: '90%', textAlign: 'left' }}
                            bodyStyle={{ textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '25%', padding: CELL_PADDING, paddingLeft: 0}}></Column>

                        <Column header="Color" align="center"  alignHeader="center"
                            headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'center'}} 
                            bodyStyle={{ padding: CELL_PADDING, textAlign: 'center' }} body={colorTemplate}></Column>

                         {/* <Column header="Selectable" align="center"  alignHeader="center"
                            headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'center' , width: '10%' }} 
                            bodyStyle={{ padding: CELL_PADDING, textAlign: 'center',  width: '10%'  }} body={selectableTemplate}></Column> */}
                    </TreeTable>
                </Box>

                
                <DocumentEffectivityChooserDialog open={effDialogOpen} onCancel={() => setEffDialogOpen(false)} onSave={handleEffSave} instance={instance} />
                <ColorPickerDialog open={colorDialogOpen} color={colorDialogValue} onCancel={() => setColorDialogOpen(false)} onSave={handleColorSave} disableAlpha={true} />
                <EditTitleDialog open={titleDialogOpen} value={titleDialogValue} onCancel={() => setTitleDialogOpen(false)} onSave={handleTitleDialogSave} />
            </DialogContent>
            <DialogActions sx={{padding: 3, paddingTop: 1, display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{ paddingTop: '1em', display: 'flex' }}>
                    <Tooltip title="Add">
                        <span>
                            <IconButton color="inherit" onClick={handleAddAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                                <AddIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <span>
                            <IconButton disabled={!deleteEnabled} color="inherit" onClick={handleDeleteAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                                <DeleteIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Move Up">
                        <span>
                            <IconButton disabled={!moveupEnabled} color="inherit" onClick={handleMoveupAction} sx={{marginLeft: 4, paddingLeft: '6px', paddingRight: '6px'}}>
                                <MoveUpIcon color="inherit"/>
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Move Down">
                        <span>
                            <IconButton disabled={!movedownEnabled} color="inherit" onClick={handleMovedownAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                                <MoveDownIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Move In" >
                        <span>
                            <IconButton disabled={!moveupEnabled} color="inherit" onClick={handleMoveinAction}
                                sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }} >
                                <DriveFileMoveIcon color="inherit"/>
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Move Out">
                        <span>
                            <IconButton disabled={!moveoutEnabled} color="inherit" onClick={handleMoveoutAction}
                                sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }} >
                                <DriveFileMoveRtlIcon color="inherit"/>
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );

}

function CreateDocumentEffectivityPanel(props) {
    const {
        title = 'Create Document—Effectivity',
        instance = null,
        open,
        onChange,
        onSave,
        onCancel,
        ...other
    } = props;

    const [effNodes, setEffNodes] = useState([]); // Effectivity Config entries
    const [effList, setEffList] = useState([]); // same as effNodes but items are flatten into a list
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null);
    const [colorNode, setColorNode] = useState(null); // focused node, may not be the selected
    const [expandedKeys, setExpandedKeys] = useState({});

    const [config, setConfig] = useState(null); // DLib config id (Long)
    const [operator, setOperator] = useState('');
    const [okEnabled, setOkEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [moveupEnabled, setMoveupEnabled] = useState(false);
    const [movedownEnabled, setMovedownEnabled] = useState(false);
    const [moveoutEnabled, setMoveoutEnabled] = useState(false);

    const [effDialogOpen, setEffDialogOpen] = useState(false);
    const [colorDialogOpen, setColorDialogOpen] = useState(false);
    const [colorDialogValue, setColorDialogValue] = useState('#000');

    const [titleDialogOpen, setTitleDialogOpen] = useState(false);
    const [titleDialogValue, setTitleDialogValue] = useState('');
    const [titleDialogNode, setTitleDialogNode] = useState(null);

    const docGeneral = useSelector((state) => state.documentConfig.general);
    const docEff = useSelector((state) => state.documentConfig.effectivity);
    
    
    const dispatch = useDispatch();

    const CELL_PADDING = '0.8ex';
    const COLOR_MY_LOCK = 'green';
    const COLOR_OTHER_LOCK = '#cc0000';
    const COLOR_CHILD_LOCK = '#e0d910'; // '#e6df19';
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };


    useEffect( () => {
        netGet('/config/realm')
            .then(response => response.json())
            .then(rinfo => {
                if ( rinfo?.realm ) {
                    setOperator(rinfo.realm);
                }
            }).catch ( error => {
                console.log('Error fetching realm name: ' + error);
            });
    },[]);

    useEffect( () => {
        // if ( open && instance ) {
        if ( docEff ) {
            setErrorMessage('');
            // loadInstanceConfiguration(instance);
            setSelectedNode(null);
            setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setOkEnabled(false);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);

            const seff = JSON.stringify(docEff);
            setEffNodes(JSON.parse(seff));
        } else {
            setEffNodes([]);
            setConfig(null);
            setErrorMessage('Please set required fields');
            setOkEnabled(false);
            setSelectedNode(null);
            setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'GEN', openWorkflowId: instance?.id}));
        // }

    },[docEff]);

    const loadInstanceConfiguration = (inst) => {
        setEffNodes([]);
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.properties?.document) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config);
                    let nodes = config.properties?.eff?.source ? config.properties.eff.source : [];
                    if ( !Array.isArray(nodes) ) {
                        nodes = [];
                    }
                    const elist = [];
                    flattenTree(elist, nodes);
                    setEffNodes(nodes);
                    setEffList(elist);
                    setOkEnabled(false);
                    /*
                    const m = config.properties?.general?.model ? config.properties.general.model : '';
                    setTypeValue(m);
                    const om = config.properties?.general?.otherModel ? config.properties.general.otherModel : '';
                    setOtherValue(om);
                    const s = config.properties?.general?.shortName ? config.properties.general.shortName : '';
                    setShortNameValue(s);
                    const os = config.properties?.general?.otherShortName ? config.properties.general.otherShortName : '';
                    setOtherShortValue(os);
                    if ( config.description ) {
                        setDescriptionValue(config.description);
                    }
                    let n = config.properties?.general?.displayName ? config.properties?.general?.displayName : inst.properties?.instanceName;
                    if ( !n ) {
                        n = '';
                    }
                    computeOkEnable(inst.properties?.document, n, m, om, s, os);
                    */
                   
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = () => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        
        // console.log('OK enabled = ' + value);
        setOkEnabled(true);
    };


    /*
    React.useEffect(() => {
        

    }, []);
    */

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = { ...config };
            if ( !vv.name ) {
                vv.name = instance?.properties?.document;
            }
            if ( !vv.properties) {
                vv.properties = {};
            }
            if ( !vv.properties.eff) {
                vv.properties.eff = {};
            }
            vv.properties.eff.source = [...effNodes];            
            onSave(vv, action);
        }
    }

    const onNextClick = () => {
        onOKClick('NEXT');
    };

    const onPreviousClick = () => {
        const action = okEnabled ? 'PREV_OK' : 'PREV_CANCEL';
        onOKClick(action);
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const handleAddAction = () => {
        setEffDialogOpen(true);
        // clear selection so we don't get funnies
        setSelectedNodeKey({});
        setSelectedNode(null);
        setDeleteEnabled(false);
        setMoveupEnabled(false);
        setMovedownEnabled(false);
    };

    const handleSelectedNodeKey = (event) => {
        console.log('Selected Node key: ' + JSON.stringify(event?.value) );
        // console.log('Selected Node other: ' + JSON.stringify(other) );
        if (event.value) {
            setSelectedNodeKey(event.value);
            // console.log('Selected node keys: ' + JSON.stringify(Object.keys(event.value)));
            if (typeof event.value === 'string') {
                const sn = effList.find(n => n.key === event.value);
                setSelectedNode(sn);
                // setCurrentNode(sn);
                if (sn) {
                    setDeleteEnabled(true);
                } else {
                    setDeleteEnabled(false);
                }
                const si = effList.findIndex(n => n.key === event.value);
                setMoveupEnabled(si > 0);
                setMovedownEnabled(si >= 0 && si < effList.length - 1);
            } else {
                let sn = null;
                let skey = null;
                const size = Object.keys(event.value).length;
                for(let key in event.value) {
                    if ( typeof event.value[key] === 'boolean' && event.value[key] ) {
                        sn = effList.find(n => n.key === key);
                        // size++;
                        skey = key;
                        if ( sn ) {
                            break;
                        }
                    }
                }
                if ( sn ) {
                    setDeleteEnabled(true);
                    setSelectedNode(sn);
                } else {
                    setDeleteEnabled(false);
                    setSelectedNode(null);
                }
                if ( size === 1 ) {
                    // console.log('Finding key: ' + skey);
                    const si = effList.findIndex(n => n.key === skey);
                    if ( si >= 0 ) {
                        const sn = effList[si];
                        setMoveupEnabled(si > 0);
                        setMovedownEnabled(si < effList.length - 1);
                        setMoveoutEnabled(typeof sn?.data?.kparent === 'string' && !sn.data.kparent.length > 0);
                    }
                } else {
                    // console.log('MULTIPLE');
                    setMoveupEnabled(false);
                    setMovedownEnabled(false);
                    setMoveoutEnabled(false);
                    // setSelectedNodeKey({});
                }
            }
        } else {
            setSelectedNodeKey(null);
            // setCurrentNode(null);
            setSelectedNode(null);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
            setMoveoutEnabled(false);
        }
    };

    const handleSelectedNode = (event) => {
        console.log('Selected Node: ' + JSON.stringify(event.node?.key) );
        setSelectedNode(event.node);
        /*
        const keys = {};
        if ( event.node?.key ) {
            keys[event.node.key] = true;
        }
        setSelectedNodeKey(keys);
        */
        // setCurrentNode(event.node);
    };

    const handleToggleNode = (event) => {
        setExpandedKeys(event.value);
    };

    const toggleNode = (node) => {
        let xkeys = expandedKeys ? { ...expandedKeys } : {};
        if (xkeys[node.key]) {
            delete xkeys[node.key];
        } else {
            xkeys[node.key] = true;
        }
        setExpandedKeys(xkeys);
    };

    const flattenTree = ( list, tree ) => {
        if (Array.isArray(tree) ) {
            tree.forEach( t => {
                list.push(t);
                if ( Array.isArray(t.children) ) {
                    flattenTree(list, t.children);
                }
            });
        }
    };

    const docTemplate = (node, options) => {
        let label = node?.data?.dlabel;
        let prefix = node?.data?.doc?.root ? '' : (node?.data?.doc?.code ? node.data.doc.code : '') + ' ';
        if ( !prefix || prefix === '-' ) {
            prefix = '';
        }
        
        const i = effList.findIndex( n => n.key === node.key );
        /*
        const en = effNodes.map(n => n.key);
        console.log('Current nodes = ' + JSON.stringify(en));
        console.log('My index = ' + i + ' key = ' + node.key);
        */
        if ( i > 0 ) {
            const prev = effList[i-1];
            if ( prev?.data?.dlabel === label ) {
                label = '';
                prefix = '';
            }
        }
        return (
            <Typography>{prefix + label}</Typography>
        );
    };

    const handleColorClick = (node) => {
        setColorDialogOpen(true);
        const c = node?.data?.color  ? node.data.color : '#000';
        setColorNode(node);
        setColorDialogValue(c);
    };

    const handleColorSave = (color) => {
        setColorDialogOpen(false);
        // console.log('Color = ' + JSON.stringify(color));
        
        if ( colorNode ) {
            const ee = [...effNodes];
            const elist = [];
            flattenTree(elist, ee);
            const cn = elist.find( n => n.key === colorNode.key);
            /*
            const ci = elist.findIndex(n => n.key === colorNode.key);
            // console.log('Selected color node = ' + JSON.stringify(cn));
            if ( ci >= 0 ) {
                const cnn = {...elist[ci]};
                cnn['data'] = {...cnn.data};
                cnn.data.color = color;
                elist[ci] = cnn;
                setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
                if ( typeof onChange === 'function' ) {
                    onChange(ee);
                }
            }
            */
            
            if ( cn ) {
                // cn['data'] = {...cn.data};
                cn.data.color = color;
                setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
                if ( typeof onChange === 'function' ) {
                    onChange(ee);
                }
            }
            
        } else {
            console.log('No current node!');
        }
    };

    const labelTemplate = (node, options) => {
        /*
        return (
            <Button variant="text" onClick={() => toggleNode(node)} 
            sx={{ color: 'rgba(0,0,0,0.87)', textAlign: 'left', minWidth: '7em', justifyContent: 'flex-start', textTransform: 'none' }}>{node?.data?.ename}</Button>
        );
        */
       return (
        <Typography>{node.data?.ename}</Typography>
       )
    };

    const getSelectable = (node) => {
        if ( node ) {
            if ( typeof node.data.select === 'boolean' ) {
                return node.data.select;
            } 
        }
        return true;
    }

    const onSelectableChange = (node, event) => {
        console.log('Selectable: ' + node.key + ' ' + event.target.checked);
        if ( node ) {
            const ee = [...effNodes];
            const elist = [];
            flattenTree(elist, ee);
            const cn = elist.find( n => n.key === node.key);
            // console.log('Selected color node = ' + JSON.stringify(cn));
            if ( cn ) {
                cn.data.select = event.target.checked;
                setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
            }
        }

    }

    const selectableTemplate = (node, options) => {
        return (
            <Checkbox checked={getSelectable(node)} onChange={(event) => onSelectableChange(node, event)} />
        );
    };

    const handleTitleClick = (node) => {
        setTitleDialogNode(node);
        setTitleDialogValue(node.data?.title ? node.data.title : node.data?.ename);
        setTitleDialogOpen(true);

    };

    const handleTitleDialogSave = (value) => {
        setTitleDialogOpen(false);
        const node = titleDialogNode;
        if (node) {
            if (node) {
                node.data.title = value;
                setOkEnabled(true);
            }
        }
    }

    const titleTemplate = (node, options) => {
        return (
            <Button variant="text" onClick={() => handleTitleClick(node)} 
                sx={{textAlign: 'left', padding: 0, justifyContent: 'start', color: 'inherit', textTransform: 'none'}}
                >{node.data?.title ? node.data.title : node.data?.ename}</Button>
        );
    };

    const colorTemplate = (node, options) => {
        const color = node?.data?.color  ? node.data.color : '#000';
        return (
            <IconButton onClick={() => handleColorClick(node)}>
                <Brightness1Icon fontSize="small" sx={{color: color}} />
            </IconButton>
        );
    };

    const loadLabelMap = (model, labelmap) => {
        if (Array.isArray(model) && model.length > 0 ) {
            model.forEach(item => {
                labelmap[item.data.elabel] = item;
                loadLabelMap(item.children, labelmap);
            });
        }
    };

    const findNode = (root, node) => {
        if ( root.key === node.key ) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNode(c, node);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    };

    const findNodeByLabel = (root, label) => {
        if ( root.data.elabel === label) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNodeByLabel(c, label);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    }

    const isDescendant = (root, node) => {
        if ( Array.isArray(node.data?.item?.ancestorLabels) ) {
            for(let i=0; i<node.data.item.ancestorLabels.length; i++) {
                const label = node.data.item.ancestorLabels[i];
                if ( root.data.elabel === label ) {
                    return true;
                }
            }
        }
        return false;
    };

    const mergeNode = (root, node) => {
        const tn = findNode(root, node);
        if ( tn ) { // already in tree
            if ( Array.isArray(node.children) && node.children.length > 0 ) {
                for(let i=0; i<node.children.length; i++) {
                    const tc = node.children[i];
                    mergeNode(tn, tc);
                }
            }
            // node already matched, even if no further merging down the descendants
            return true; 
            
        } else {
            if ( Array.isArray(node.data?.item?.ancestorLabels) ) {
                for(let i=0; i< node.data.item.ancestorLabels.length; i++) {
                    const label = node.data.item.ancestorLabels[i];
                    
                    const ln = findNodeByLabel(root, label);
                    // console.log('Test label = ' + label + ' : ' + ln);
                    if ( ln ) {
                        // found and ancestor, insert it
                        const nchildren = [];
                        if ( !Array.isArray(node.children) ) {
                            node.children = [];
                        }
                        if ( Array.isArray(ln.children) ) {
                            ln.children.forEach( c => {
                                if ( isDescendant(node, c) ) {
                                    c.data.pkey = node.key;
                                    node.children.push(c);
                                } else {
                                    c.data.pkey = ln.key;
                                    nchildren.push(c);
                                }
                            });
                        }
                        nchildren.push(node);
                        node.children.sort( (a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        nchildren.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        ln.children = nchildren;
                        return true;
                    }
                }
            }
        }
        return false;
    };

    const addNodes = (enodes, nodes) => {
        if ( Array.isArray(nodes) ) {
            nodes.forEach( n => {
                let m = false;
                for(let i=0; i<enodes.length; i++) {
                    const tn = enodes[i];
                    if ( tn.data?.doc?.id === n.data?.doc?.id) {
                        m = mergeNode(tn, n);
                        if ( m ) {
                            break;
                        }
                    }
                }
                if ( !m ) {
                    enodes.push(n);
                    // console.log('NOT MERGED: ' + JSON.stringify(n) );
                    // console.log('EFF NODES: ' + JSON.stringify(ee));
                }
            });
            enodes.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);            
        }
    };

    const handleEffSave = (nodes) => {
        setEffDialogOpen(false);
        const ee = [...effNodes];
        // simply append nodes, let admin organize as desired, including removing duplicates
        nodes.forEach ( n => ee.push(n));
        const elist = [];
        flattenTree(elist, ee);
        setEffList(elist);
        setEffNodes(ee);
        setOkEnabled(true);
        if (typeof onChange === 'function') {
            onChange(ee);
        }
    };

    const handleEffSaveOld = (nodes) => {
        setEffDialogOpen(false);
        // console.log('New Tree Nodes: ' + JSON.stringify(nodes.map(n => n.key)));
        // console.log('New Tree Nodes: ' + JSON.stringify(nodes));
        const ee = [...effNodes];
        
        addNodes(ee, nodes);

        // do a second pass collecting nodes that may belong inside other others
        const rns = []; // nodes to remove and merge elsewhere
        for(let i=0; i<ee.length; i++) {
            const ni = ee[i];
            for(let j=0; j<ee.length; j++) {
                if ( i !== j ) {
                    const nj = ee[j];
                    if ( Array.isArray(nj.data.item.ancestorLabels) ) {
                        for(let k=0; k<nj.data.item.ancestorLabels.length; k++) {
                            const label = nj.data.item.ancestorLabels[k];
                            if ( ni.data.elabel === label ) {
                                rns.push(nj);
                                break;
                            }
                        }
                    }
                }
            }
        }
        if ( rns.length > 0 ) {
            rns.forEach( n => {
                const ri = ee.findIndex( m => m.key === n.key);
                if ( ri >= 0 ) {
                    ee.splice(ri, 1);
                }
            });
            addNodes(ee, rns);
        }
        ee.sort( (a,b) => a.data?.doc?.seq - b.data?.doc?.seq);
        // console.log('New Eff Nodes: ' + JSON.stringify(ee));
        const elist = [];
        flattenTree(elist, ee);
        setEffList(elist);
        setEffNodes(ee);
        setOkEnabled(true);
    }

    const deleteNode = (enodes, key) => {
        const elist = [];
        flattenTree(elist, enodes);
        const dn = elist.find(n => n.key === key);
        if (dn) {
            const pn = dn.data?.pkey ? elist.find(n => n.key === dn.data?.pkey) : null;
            if (pn) {
                // remove from internal node
                const i = Array.isArray(pn.children) ? pn.children.findIndex(n => n.key === dn.key) : -1;
                if (i >= 0) {
                    pn.children.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            pn.children.push(c);
                            c.data.pkey = pn.key;
                        });
                        pn.children.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }

                }
            } else {
                // remove from effNodes
                const i = enodes.findIndex(n => n.key === dn.key);
                if (i >= 0) {
                    enodes.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            enodes.push(c);
                            c.data.pkey = null;
                        });
                        enodes.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }
                }
            }
            // elist.splice(0, elist.length);
            //flattenTree(elist, enodes);
            // setEffNodes(enodes);
            // setEffList(elist);
        }
    };

    const handleDeleteAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                deleteNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key] ) {
                        deleteNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
            if (typeof onChange === 'function') {
                onChange(enodes);
            }
        }
    };

    const handleMoveupAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                moveUpNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key]) {
                        moveUpNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
            if (typeof onChange === 'function') {
                onChange(enodes);
            }
        }
    };

    const moveUpNode = (enodes, key) => {
        // only move top nodes
        const i = enodes.findIndex(n => n.key === key);
        console.log('Node index = ' + i);
        if ( i > 0 ) {
            const node = enodes[i];
            const pnode = enodes[i-1];
            enodes[i] = pnode;
            enodes[i-1] = node;
        }

    };

    const handleMovedownAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                moveDownNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key]) {
                        moveDownNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
            if (typeof onChange === 'function') {
                onChange(enodes);
            }
        }
    };

    const moveDownNode = (enodes, key) => {
        // only move top nodes
        const i = enodes.findIndex(n => n.key === key);
        if ( i < enodes.length - 1 ) {
            const node = enodes[i];
            const fnode = enodes[i+1];
            enodes[i+1] = node;
            enodes[i] = fnode;
        }

    };

    const handleMoveinAction = () => {
        // move in (indent right) under previous node that is one level down
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                moveUpNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key]) {
                        moveInNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
            if (typeof onChange === 'function') {
                onChange(enodes);
            }
        }

    };

    const moveInNode = (enodes, key) => {
        // only move top nodes
        const i = enodes.findIndex(n => n.key === key);
        console.log('Node IN index = ' + i);
        if ( i > 0 ) {
            const node = enodes[i];
            const pnode = enodes[i-1];
            enodes.splice(i, 1);
            if ( !Array.isArray(pnode.children) ) {
                pnode.children = [];
            }
            pnode.children.push(node);
            /*
            const pnode = enodes[i-1];
            enodes[i] = pnode;
            enodes[i-1] = node;
            */
        }

    };

    const handleMoveoutAction = () => {
        // move out (indent left) of current parent on level up

    };

    const handleDeleteAction2 = () => {
        if ( selectedNodeKey ) {
            const enodes = [...effNodes];
            let elist = [];
            flattenTree(elist, enodes);
            const dn = elist.find( n => n.key === selectedNodeKey);
            if ( dn ) {
                const pn = dn.data?.pkey ? elist.find( n => n.key === dn.data?.pkey) : null;
                if ( pn ) {
                    // remove from internal node
                    const i = Array.isArray(pn.children) ? pn.children.findIndex( n => n.key === dn.key) : -1;
                    if ( i >= 0 ) {
                        pn.children.splice(i, 1);
                        if ( Array.isArray(dn.children) && dn.children.length > 0 ) {
                            dn.children.forEach( c => {
                                pn.children.push(c);
                                c.data.pkey = pn.key;
                            });
                            pn.children.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        }
                        
                    }
                } else {
                    // remove from effNodes
                    const i = enodes.findIndex( n => n.key === dn.key);
                    if ( i >= 0 ) {
                        enodes.splice(i, 1);
                        if ( Array.isArray(dn.children) && dn.children.length > 0 ) {
                            dn.children.forEach( c => {
                                enodes.push(c);
                                c.data.pkey = null;
                            });
                            enodes.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        }
                    }
                }
                elist = [];
                flattenTree(elist, enodes);
                setEffNodes(enodes);
                setEffList(elist);
            }
        }
    };
    

    return (
        <Box>

            <Box sx={{ overflow: 'hidden', paddingTop: '2em', height: '620px' }}>
                <TreeTable value={effNodes} tableStyle={{ width: '100%', }} emptyMessage={<span></span>}

                    selectionKeys={selectedNodeKey} expandedKeys={expandedKeys} onToggle={handleToggleNode}
                    selectionMode="multiple" onSelectionChange={handleSelectedNodeKey} onSelect={handleSelectedNode} metaKeySelection={true}
                    scrollable scrollHeight="580px" overflow="auto"
                    defaultSortOrder={0} rowHover >

                    <Column body={docTemplate} header="Document Part" align="left"
                        headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'left', width: '20%' }}
                        bodyStyle={{ padding: CELL_PADDING, textAlign: 'left', width: "20%" }} ></Column>

                    <Column field="ename" header="Effectivity" align="left" alignHeader="left" style={{ padding: 0, paddingLeft: '1ex', textAlign: 'left', width: '35%' }}
                        headerStyle={{ padding: '0.9ex', width: '35%', fontSize: '90%', textAlign: 'left' }}
                        bodyStyle={{ textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '35%', padding: CELL_PADDING, }}
                        expander ></Column>

                    <Column body={titleTemplate} header="Node Label" align="left" alignHeader="left" style={{ padding: 0, paddingLeft: '1ex', textAlign: 'left', width: '25%' }}
                        headerStyle={{ padding: '0.9ex', paddingLeft: 0, width: '25%', fontSize: '90%', textAlign: 'left' }}
                        bodyStyle={{ textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '25%', padding: CELL_PADDING, paddingLeft: 0 }}></Column>

                    <Column header="Color" align="center" alignHeader="center"
                        headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'center' }}
                        bodyStyle={{ padding: CELL_PADDING, textAlign: 'center' }} body={colorTemplate}></Column>

                    {/* <Column header="Selectable" align="center"  alignHeader="center"
                            headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'center' , width: '10%' }} 
                            bodyStyle={{ padding: CELL_PADDING, textAlign: 'center',  width: '10%'  }} body={selectableTemplate}></Column> */}
                </TreeTable>
            </Box>

            <Box sx={{ paddingTop: '1em', display: 'flex' }}>
                <Tooltip title="Add">
                    <span>
                        <IconButton color="inherit" onClick={handleAddAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <AddIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete">
                    <span>
                        <IconButton disabled={!deleteEnabled} color="inherit" onClick={handleDeleteAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <DeleteIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Move Up">
                    <span>
                        <IconButton disabled={!moveupEnabled} color="inherit" onClick={handleMoveupAction} sx={{ marginLeft: 4, paddingLeft: '6px', paddingRight: '6px' }}>
                            <MoveUpIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Move Down">
                    <span>
                        <IconButton disabled={!movedownEnabled} color="inherit" onClick={handleMovedownAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <MoveDownIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Move In" >
                    <span>
                        <IconButton disabled={!moveupEnabled} color="inherit" onClick={handleMoveinAction}
                            sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }} >
                            <DriveFileMoveIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Move Out">
                    <span>
                        <IconButton disabled={!moveoutEnabled} color="inherit" onClick={handleMoveoutAction}
                            sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }} >
                            <DriveFileMoveRtlIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>

            <DocumentEffectivityChooserDialog open={effDialogOpen} onCancel={() => setEffDialogOpen(false)} onSave={handleEffSave} instance={docGeneral} />
            <ColorPickerDialog open={colorDialogOpen} color={colorDialogValue} onCancel={() => setColorDialogOpen(false)} onSave={handleColorSave} disableAlpha={true} />
            <EditTitleDialog open={titleDialogOpen} value={titleDialogValue} onCancel={() => setTitleDialogOpen(false)} onSave={handleTitleDialogSave} />
        </Box>

    );

}

function EditDocumentEffectivityPanel(props) {
    const {
        title = 'Effectivity',
        document,
        open,
        onChange,
        onSave,
        onCancel,
        readOnly=false,
        ...other
    } = props;

    const [effNodes, setEffNodes] = useState([]); // Effectivity Config entries
    const [effList, setEffList] = useState([]); // same as effNodes but items are flatten into a list
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null);
    const [colorNode, setColorNode] = useState(null); // focused node, may not be the selected
    const [expandedKeys, setExpandedKeys] = useState({});

    const [config, setConfig] = useState(null); // DLib config id (Long)
    const [operator, setOperator] = useState('');
    const [okEnabled, setOkEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [moveupEnabled, setMoveupEnabled] = useState(false);
    const [movedownEnabled, setMovedownEnabled] = useState(false);
    const [moveoutEnabled, setMoveoutEnabled] = useState(false);

    const [effDialogOpen, setEffDialogOpen] = useState(false);
    const [colorDialogOpen, setColorDialogOpen] = useState(false);
    const [colorDialogValue, setColorDialogValue] = useState('#000');

    const [titleDialogOpen, setTitleDialogOpen] = useState(false);
    const [titleDialogValue, setTitleDialogValue] = useState('');
    const [titleDialogNode, setTitleDialogNode] = useState(null);

    // const docGeneral = useSelector((state) => state.documentConfig.general);
    // const docEff = useSelector((state) => state.documentConfig.effectivity);
    
    
    const dispatch = useDispatch();

    const CELL_PADDING = '0.8ex';
    const COLOR_MY_LOCK = 'green';
    const COLOR_OTHER_LOCK = '#cc0000';
    const COLOR_CHILD_LOCK = '#e0d910'; // '#e6df19';
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };


    useEffect( () => {
        netGet('/config/realm')
            .then(response => response.json())
            .then(rinfo => {
                if ( rinfo?.realm ) {
                    setOperator(rinfo.realm);
                }
            }).catch ( error => {
                console.log('Error fetching realm name: ' + error);
            });
    },[]);

    useEffect( () => {
        if ( open && document ) {
        // if ( docEff ) {
            setErrorMessage('');
            loadInstanceConfiguration(document);
            setSelectedNode(null);
            setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setOkEnabled(false);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);

            // const seff = JSON.stringify(docEff);
            // setEffNodes(JSON.parse(seff));
        } else {
            setEffNodes([]);
            setConfig(null);
            setErrorMessage('Please set required fields');
            setOkEnabled(false);
            setSelectedNode(null);
            setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'GEN', openWorkflowId: instance?.id}));
        // }

    },[open,document]);

    const loadInstanceConfiguration = (inst) => {
        setEffNodes([]);
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.id) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config);
                    let nodes = config.properties?.eff?.source ? config.properties.eff.source : [];
                    if ( !Array.isArray(nodes) ) {
                        nodes = [];
                    }
                    const elist = [];
                    flattenTree(elist, nodes);
                    setEffNodes(nodes);
                    setEffList(elist);
                    setOkEnabled(false);
                    /*
                    const m = config.properties?.general?.model ? config.properties.general.model : '';
                    setTypeValue(m);
                    const om = config.properties?.general?.otherModel ? config.properties.general.otherModel : '';
                    setOtherValue(om);
                    const s = config.properties?.general?.shortName ? config.properties.general.shortName : '';
                    setShortNameValue(s);
                    const os = config.properties?.general?.otherShortName ? config.properties.general.otherShortName : '';
                    setOtherShortValue(os);
                    if ( config.description ) {
                        setDescriptionValue(config.description);
                    }
                    let n = config.properties?.general?.displayName ? config.properties?.general?.displayName : inst.properties?.instanceName;
                    if ( !n ) {
                        n = '';
                    }
                    computeOkEnable(inst.properties?.document, n, m, om, s, os);
                    */
                   
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = () => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        
        // console.log('OK enabled = ' + value);
        setOkEnabled(true);
    };


    /*
    React.useEffect(() => {
        

    }, []);
    */

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = { ...config };
            if ( !vv.name ) {
                vv.name = document.title;
            }
            if ( !vv.properties) {
                vv.properties = {};
            }
            if ( !vv.properties.eff) {
                vv.properties.eff = {};
            }
            vv.properties.eff.source = [...effNodes];            
            onSave(vv, action);
        }
    }

    const onNextClick = () => {
        onOKClick('NEXT');
    };

    const onPreviousClick = () => {
        const action = okEnabled ? 'PREV_OK' : 'PREV_CANCEL';
        onOKClick(action);
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const handleAddAction = () => {
        setEffDialogOpen(true);
        // clear selection so we don't get funnies
        setSelectedNodeKey({});
        setSelectedNode(null);
        setDeleteEnabled(false);
        setMoveupEnabled(false);
        setMovedownEnabled(false);
    };

    const handleSelectedNodeKey = (event) => {
        console.log('Selected Node key: ' + JSON.stringify(event?.value) );
        // console.log('Selected Node other: ' + JSON.stringify(other) );
        if (event.value) {
            setSelectedNodeKey(event.value);
            // console.log('Selected node keys: ' + JSON.stringify(Object.keys(event.value)));
            if (typeof event.value === 'string') {
                const sn = effList.find(n => n.key === event.value);
                setSelectedNode(sn);
                // setCurrentNode(sn);
                if (sn) {
                    setDeleteEnabled(true);
                } else {
                    setDeleteEnabled(false);
                }
                const si = effList.findIndex(n => n.key === event.value);
                setMoveupEnabled(si > 0);
                setMovedownEnabled(si >= 0 && si < effList.length - 1);
            } else {
                let sn = null;
                let skey = null;
                const size = Object.keys(event.value).length;
                for(let key in event.value) {
                    if ( typeof event.value[key] === 'boolean' && event.value[key] ) {
                        sn = effList.find(n => n.key === key);
                        // size++;
                        skey = key;
                        if ( sn ) {
                            break;
                        }
                    }
                }
                if ( sn ) {
                    setDeleteEnabled(true);
                    setSelectedNode(sn);
                } else {
                    setDeleteEnabled(false);
                    setSelectedNode(null);
                }
                if ( size === 1 ) {
                    // console.log('Finding key: ' + skey);
                    const si = effList.findIndex(n => n.key === skey);
                    if ( si >= 0 ) {
                        const sn = effList[si];
                        setMoveupEnabled(si > 0);
                        setMovedownEnabled(si < effList.length - 1);
                        setMoveoutEnabled(typeof sn?.data?.kparent === 'string' && !sn.data.kparent.length > 0);
                    }
                } else {
                    // console.log('MULTIPLE');
                    setMoveupEnabled(false);
                    setMovedownEnabled(false);
                    setMoveoutEnabled(false);
                    // setSelectedNodeKey({});
                }
            }
        } else {
            setSelectedNodeKey(null);
            // setCurrentNode(null);
            setSelectedNode(null);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
            setMoveoutEnabled(false);
        }
    };

    const handleSelectedNode = (event) => {
        console.log('Selected Node: ' + JSON.stringify(event.node?.key) );
        setSelectedNode(event.node);
        /*
        const keys = {};
        if ( event.node?.key ) {
            keys[event.node.key] = true;
        }
        setSelectedNodeKey(keys);
        */
        // setCurrentNode(event.node);
    };

    const handleToggleNode = (event) => {
        setExpandedKeys(event.value);
    };

    const toggleNode = (node) => {
        let xkeys = expandedKeys ? { ...expandedKeys } : {};
        if (xkeys[node.key]) {
            delete xkeys[node.key];
        } else {
            xkeys[node.key] = true;
        }
        setExpandedKeys(xkeys);
    };

    const flattenTree = ( list, tree ) => {
        if (Array.isArray(tree) ) {
            tree.forEach( t => {
                list.push(t);
                if ( Array.isArray(t.children) ) {
                    flattenTree(list, t.children);
                }
            });
        }
    };

    const docTemplate = (node, options) => {
        let label = node?.data?.dlabel;
        let prefix = node?.data?.doc?.root ? '' : (node?.data?.doc?.code ? node.data.doc.code : '') + ' ';
        if ( !prefix || prefix === '-' ) {
            prefix = '';
        }
        
        const i = effList.findIndex( n => n.key === node.key );
        /*
        const en = effNodes.map(n => n.key);
        console.log('Current nodes = ' + JSON.stringify(en));
        console.log('My index = ' + i + ' key = ' + node.key);
        */
        if ( i > 0 ) {
            const prev = effList[i-1];
            if ( prev?.data?.dlabel === label ) {
                label = '';
                prefix = '';
            }
        }
        return (
            <Typography>{prefix + label}</Typography>
        );
    };

    const handleColorClick = (node) => {
        setColorDialogOpen(true);
        const c = node?.data?.color  ? node.data.color : '#000';
        setColorNode(node);
        setColorDialogValue(c);
    };

    const handleColorSave = (color) => {
        setColorDialogOpen(false);
        // console.log('Color = ' + JSON.stringify(color));
        
        if ( colorNode ) {
            const ee = [...effNodes];
            const elist = [];
            flattenTree(elist, ee);
            const cn = elist.find( n => n.key === colorNode.key);
            /*
            const ci = elist.findIndex(n => n.key === colorNode.key);
            // console.log('Selected color node = ' + JSON.stringify(cn));
            if ( ci >= 0 ) {
                const cnn = {...elist[ci]};
                cnn['data'] = {...cnn.data};
                cnn.data.color = color;
                elist[ci] = cnn;
                setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
                if ( typeof onChange === 'function' ) {
                    onChange(ee);
                }
            }
            */
            
            if ( cn ) {
                // cn['data'] = {...cn.data};
                cn.data.color = color;
                setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
                if ( typeof onChange === 'function' ) {
                    onChange(ee);
                }
            }
            
        } else {
            console.log('No current node!');
        }
    };

    const labelTemplate = (node, options) => {
        /*
        return (
            <Button variant="text" onClick={() => toggleNode(node)} 
            sx={{ color: 'rgba(0,0,0,0.87)', textAlign: 'left', minWidth: '7em', justifyContent: 'flex-start', textTransform: 'none' }}>{node?.data?.ename}</Button>
        );
        */
       return (
        <Typography>{node.data?.ename}</Typography>
       )
    };

    const getSelectable = (node) => {
        if ( node ) {
            if ( typeof node.data.select === 'boolean' ) {
                return node.data.select;
            } 
        }
        return true;
    }

    const onSelectableChange = (node, event) => {
        console.log('Selectable: ' + node.key + ' ' + event.target.checked);
        if ( node ) {
            const ee = [...effNodes];
            const elist = [];
            flattenTree(elist, ee);
            const cn = elist.find( n => n.key === node.key);
            // console.log('Selected color node = ' + JSON.stringify(cn));
            if ( cn ) {
                cn.data.select = event.target.checked;
                setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
            }
        }

    }

    const selectableTemplate = (node, options) => {
        return (
            <Checkbox checked={getSelectable(node)} onChange={(event) => onSelectableChange(node, event)} />
        );
    };

    const handleTitleClick = (node) => {
        setTitleDialogNode(node);
        setTitleDialogValue(node.data?.title ? node.data.title : node.data?.ename);
        setTitleDialogOpen(true);

    };

    const handleTitleDialogSave = (value) => {
        setTitleDialogOpen(false);
        const node = titleDialogNode;
        if (node) {
            if (node) {
                node.data.title = value;
                setOkEnabled(true);
            }
        }
    }

    const titleTemplate = (node, options) => {
        return (
            <Button variant="text" onClick={() => handleTitleClick(node)} disabled={readOnly}
                sx={{textAlign: 'left', padding: 0, justifyContent: 'start', color: 'inherit', textTransform: 'none'}}
                >{node.data?.title ? node.data.title : node.data?.ename}</Button>
        );
    };

    const colorTemplate = (node, options) => {
        const color = node?.data?.color  ? node.data.color : '#000';
        return (
            <IconButton onClick={() => handleColorClick(node)} disabled={readOnly}>
                <Brightness1Icon fontSize="small" sx={{color: color}} />
            </IconButton>
        );
    };

    const loadLabelMap = (model, labelmap) => {
        if (Array.isArray(model) && model.length > 0 ) {
            model.forEach(item => {
                labelmap[item.data.elabel] = item;
                loadLabelMap(item.children, labelmap);
            });
        }
    };

    const findNode = (root, node) => {
        if ( root.key === node.key ) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNode(c, node);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    };

    const findNodeByLabel = (root, label) => {
        if ( root.data.elabel === label) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNodeByLabel(c, label);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    }

    const isDescendant = (root, node) => {
        if ( Array.isArray(node.data?.item?.ancestorLabels) ) {
            for(let i=0; i<node.data.item.ancestorLabels.length; i++) {
                const label = node.data.item.ancestorLabels[i];
                if ( root.data.elabel === label ) {
                    return true;
                }
            }
        }
        return false;
    };

    const mergeNode = (root, node) => {
        const tn = findNode(root, node);
        if ( tn ) { // already in tree
            if ( Array.isArray(node.children) && node.children.length > 0 ) {
                for(let i=0; i<node.children.length; i++) {
                    const tc = node.children[i];
                    mergeNode(tn, tc);
                }
            }
            // node already matched, even if no further merging down the descendants
            return true; 
            
        } else {
            if ( Array.isArray(node.data?.item?.ancestorLabels) ) {
                for(let i=0; i< node.data.item.ancestorLabels.length; i++) {
                    const label = node.data.item.ancestorLabels[i];
                    
                    const ln = findNodeByLabel(root, label);
                    // console.log('Test label = ' + label + ' : ' + ln);
                    if ( ln ) {
                        // found and ancestor, insert it
                        const nchildren = [];
                        if ( !Array.isArray(node.children) ) {
                            node.children = [];
                        }
                        if ( Array.isArray(ln.children) ) {
                            ln.children.forEach( c => {
                                if ( isDescendant(node, c) ) {
                                    c.data.pkey = node.key;
                                    node.children.push(c);
                                } else {
                                    c.data.pkey = ln.key;
                                    nchildren.push(c);
                                }
                            });
                        }
                        nchildren.push(node);
                        node.children.sort( (a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        nchildren.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        ln.children = nchildren;
                        return true;
                    }
                }
            }
        }
        return false;
    };

    const addNodes = (enodes, nodes) => {
        if ( Array.isArray(nodes) ) {
            nodes.forEach( n => {
                let m = false;
                for(let i=0; i<enodes.length; i++) {
                    const tn = enodes[i];
                    if ( tn.data?.doc?.id === n.data?.doc?.id) {
                        m = mergeNode(tn, n);
                        if ( m ) {
                            break;
                        }
                    }
                }
                if ( !m ) {
                    enodes.push(n);
                    // console.log('NOT MERGED: ' + JSON.stringify(n) );
                    // console.log('EFF NODES: ' + JSON.stringify(ee));
                }
            });
            enodes.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);            
        }
    };

    const handleEffSave = (nodes) => {
        setEffDialogOpen(false);
        const ee = [...effNodes];
        // simply append nodes, let admin organize as desired, including removing duplicates
        nodes.forEach ( n => ee.push(n));
        const elist = [];
        flattenTree(elist, ee);
        setEffList(elist);
        setEffNodes(ee);
        setOkEnabled(true);
        if (typeof onChange === 'function') {
            onChange(ee);
        }
    };

    const handleEffSaveOld = (nodes) => {
        setEffDialogOpen(false);
        // console.log('New Tree Nodes: ' + JSON.stringify(nodes.map(n => n.key)));
        // console.log('New Tree Nodes: ' + JSON.stringify(nodes));
        const ee = [...effNodes];
        
        addNodes(ee, nodes);

        // do a second pass collecting nodes that may belong inside other others
        const rns = []; // nodes to remove and merge elsewhere
        for(let i=0; i<ee.length; i++) {
            const ni = ee[i];
            for(let j=0; j<ee.length; j++) {
                if ( i !== j ) {
                    const nj = ee[j];
                    if ( Array.isArray(nj.data.item.ancestorLabels) ) {
                        for(let k=0; k<nj.data.item.ancestorLabels.length; k++) {
                            const label = nj.data.item.ancestorLabels[k];
                            if ( ni.data.elabel === label ) {
                                rns.push(nj);
                                break;
                            }
                        }
                    }
                }
            }
        }
        if ( rns.length > 0 ) {
            rns.forEach( n => {
                const ri = ee.findIndex( m => m.key === n.key);
                if ( ri >= 0 ) {
                    ee.splice(ri, 1);
                }
            });
            addNodes(ee, rns);
        }
        ee.sort( (a,b) => a.data?.doc?.seq - b.data?.doc?.seq);
        // console.log('New Eff Nodes: ' + JSON.stringify(ee));
        const elist = [];
        flattenTree(elist, ee);
        setEffList(elist);
        setEffNodes(ee);
        setOkEnabled(true);
    }

    const deleteNode = (enodes, key) => {
        const elist = [];
        flattenTree(elist, enodes);
        const dn = elist.find(n => n.key === key);
        if (dn) {
            const pn = dn.data?.pkey ? elist.find(n => n.key === dn.data?.pkey) : null;
            if (pn) {
                // remove from internal node
                const i = Array.isArray(pn.children) ? pn.children.findIndex(n => n.key === dn.key) : -1;
                if (i >= 0) {
                    pn.children.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            pn.children.push(c);
                            c.data.pkey = pn.key;
                        });
                        pn.children.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }

                }
            } else {
                // remove from effNodes
                const i = enodes.findIndex(n => n.key === dn.key);
                if (i >= 0) {
                    enodes.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            enodes.push(c);
                            c.data.pkey = null;
                        });
                        enodes.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }
                }
            }
            // elist.splice(0, elist.length);
            //flattenTree(elist, enodes);
            // setEffNodes(enodes);
            // setEffList(elist);
        }
    };

    const handleDeleteAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                deleteNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key] ) {
                        deleteNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
            if (typeof onChange === 'function') {
                onChange(enodes);
            }
        }
    };

    const handleMoveupAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                moveUpNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key]) {
                        moveUpNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
            if (typeof onChange === 'function') {
                onChange(enodes);
            }
        }
    };

    const moveUpNode = (enodes, key) => {
        // only move top nodes
        const i = enodes.findIndex(n => n.key === key);
        console.log('Node index = ' + i);
        if ( i > 0 ) {
            const node = enodes[i];
            const pnode = enodes[i-1];
            enodes[i] = pnode;
            enodes[i-1] = node;
        }

    };

    const handleMovedownAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                moveDownNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key]) {
                        moveDownNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
            if (typeof onChange === 'function') {
                onChange(enodes);
            }
        }
    };

    const moveDownNode = (enodes, key) => {
        // only move top nodes
        const i = enodes.findIndex(n => n.key === key);
        if ( i < enodes.length - 1 ) {
            const node = enodes[i];
            const fnode = enodes[i+1];
            enodes[i+1] = node;
            enodes[i] = fnode;
        }

    };

    const handleMoveinAction = () => {
        // move in (indent right) under previous node that is one level down
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                moveUpNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key]) {
                        moveInNode(enodes, key);
                    }
                }
            }
            const elist = [];
            flattenTree(elist, enodes);
            setEffNodes(enodes);
            setEffList(elist);
            setOkEnabled(true);
            if (typeof onChange === 'function') {
                onChange(enodes);
            }
        }

    };

    const moveInNode = (enodes, key) => {
        // only move top nodes
        const i = enodes.findIndex(n => n.key === key);
        console.log('Node IN index = ' + i);
        if ( i > 0 ) {
            const node = enodes[i];
            const pnode = enodes[i-1];
            enodes.splice(i, 1);
            if ( !Array.isArray(pnode.children) ) {
                pnode.children = [];
            }
            pnode.children.push(node);
            /*
            const pnode = enodes[i-1];
            enodes[i] = pnode;
            enodes[i-1] = node;
            */
        }

    };

    const handleMoveoutAction = () => {
        // move out (indent left) of current parent on level up

    };

    const handleDeleteAction2 = () => {
        if ( selectedNodeKey ) {
            const enodes = [...effNodes];
            let elist = [];
            flattenTree(elist, enodes);
            const dn = elist.find( n => n.key === selectedNodeKey);
            if ( dn ) {
                const pn = dn.data?.pkey ? elist.find( n => n.key === dn.data?.pkey) : null;
                if ( pn ) {
                    // remove from internal node
                    const i = Array.isArray(pn.children) ? pn.children.findIndex( n => n.key === dn.key) : -1;
                    if ( i >= 0 ) {
                        pn.children.splice(i, 1);
                        if ( Array.isArray(dn.children) && dn.children.length > 0 ) {
                            dn.children.forEach( c => {
                                pn.children.push(c);
                                c.data.pkey = pn.key;
                            });
                            pn.children.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        }
                        
                    }
                } else {
                    // remove from effNodes
                    const i = enodes.findIndex( n => n.key === dn.key);
                    if ( i >= 0 ) {
                        enodes.splice(i, 1);
                        if ( Array.isArray(dn.children) && dn.children.length > 0 ) {
                            dn.children.forEach( c => {
                                enodes.push(c);
                                c.data.pkey = null;
                            });
                            enodes.sort((a,b) => a.data?.item?.seq - b.data?.item?.seq);
                        }
                    }
                }
                elist = [];
                flattenTree(elist, enodes);
                setEffNodes(enodes);
                setEffList(elist);
            }
        }
    };
    

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', pb: 1}}>

            <Box sx={{ overflow: 'hidden', paddingTop: '2em', height: '620px', flexGrow: '1' }}>
                <TreeTable value={effNodes} tableStyle={{ width: '100%', }} emptyMessage={<span></span>}

                    selectionKeys={selectedNodeKey} expandedKeys={expandedKeys} onToggle={handleToggleNode}
                    selectionMode="multiple" onSelectionChange={handleSelectedNodeKey} onSelect={handleSelectedNode} metaKeySelection={true}
                    scrollable scrollHeight="580px" overflow="auto"
                    defaultSortOrder={0} rowHover >

                    <Column body={docTemplate} header="Document Part" align="left"
                        headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'left', width: '20%' }}
                        bodyStyle={{ padding: CELL_PADDING, textAlign: 'left', width: "20%" }} ></Column>

                    <Column field="ename" header="Effectivity" align="left" alignHeader="left" style={{ padding: 0, paddingLeft: '1ex', textAlign: 'left', width: '35%' }}
                        headerStyle={{ padding: '0.9ex', width: '35%', fontSize: '90%', textAlign: 'left' }}
                        bodyStyle={{ textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '35%', padding: CELL_PADDING, }}
                        expander ></Column>

                    <Column body={titleTemplate} header="Node Label" align="left" alignHeader="left" style={{ padding: 0, paddingLeft: '1ex', textAlign: 'left', width: '25%' }}
                        headerStyle={{ padding: '0.9ex', paddingLeft: 0, width: '25%', fontSize: '90%', textAlign: 'left' }}
                        bodyStyle={{ textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '25%', padding: CELL_PADDING, paddingLeft: 0 }}></Column>

                    <Column header="Color" align="center" alignHeader="center"
                        headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'center' }}
                        bodyStyle={{ padding: CELL_PADDING, textAlign: 'center' }} body={colorTemplate}></Column>

                    {/* <Column header="Selectable" align="center"  alignHeader="center"
                            headerStyle={{ padding: '0.9ex', fontSize: '90%', textAlign: 'center' , width: '10%' }} 
                            bodyStyle={{ padding: CELL_PADDING, textAlign: 'center',  width: '10%'  }} body={selectableTemplate}></Column> */}
                </TreeTable>
            </Box>

            <Box sx={{ paddingTop: '1em', display: 'flex' }}>
                <Tooltip title="Add">
                    <span>
                        <IconButton disabled={readOnly} color="inherit" onClick={handleAddAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <AddIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete">
                    <span>
                        <IconButton disabled={!deleteEnabled || readOnly} color="inherit" onClick={handleDeleteAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <DeleteIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Move Up">
                    <span>
                        <IconButton disabled={!moveupEnabled || readOnly} color="inherit" onClick={handleMoveupAction} sx={{ marginLeft: 4, paddingLeft: '6px', paddingRight: '6px' }}>
                            <MoveUpIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Move Down">
                    <span>
                        <IconButton disabled={!movedownEnabled || readOnly} color="inherit" onClick={handleMovedownAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <MoveDownIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Move In" >
                    <span>
                        <IconButton disabled={!moveupEnabled || readOnly} color="inherit" onClick={handleMoveinAction}
                            sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }} >
                            <DriveFileMoveIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Move Out">
                    <span>
                        <IconButton disabled={!moveoutEnabled || readOnly} color="inherit" onClick={handleMoveoutAction}
                            sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }} >
                            <DriveFileMoveRtlIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>

            <DocumentEffectivityChooserDialog open={effDialogOpen} onCancel={() => setEffDialogOpen(false)} onSave={handleEffSave} instance={document} />
            <ColorPickerDialog open={colorDialogOpen} color={colorDialogValue} onCancel={() => setColorDialogOpen(false)} onSave={handleColorSave} disableAlpha={true} />
            <EditTitleDialog open={titleDialogOpen} value={titleDialogValue} onCancel={() => setTitleDialogOpen(false)} onSave={handleTitleDialogSave} />
        </Box>

    );

}

function CreateProcessingConfigurationDialog(props) {
    const {
        title = 'Configure Processing Outputs',
        instance = null,
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [effNodes, setEffNodes] = useState([]); // Effectivity Config entries
    // const [effList, setEffList] = useState([]); // same as effNodes but items are flatten into a list
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null);
    const [colorNode, setColorNode] = useState(null); // focused node, may not be the selected
    const [expandedKeys, setExpandedKeys] = useState({});

    const [config, setConfig] = useState(null); // DLib config id (Long)
    const [operator, setOperator] = useState('');
    const [okEnabled, setOkEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [moveupEnabled, setMoveupEnabled] = useState(false);
    const [movedownEnabled, setMovedownEnabled] = useState(false);
    const [moveoutEnabled, setMoveoutEnabled] = useState(false);

    const [effDialogOpen, setEffDialogOpen] = useState(false);
    const [colorDialogOpen, setColorDialogOpen] = useState(false);
    const [colorDialogValue, setColorDialogValue] = useState('#000');

    const [titleDialogOpen, setTitleDialogOpen] = useState(false);
    const [titleDialogValue, setTitleDialogValue] = useState('');
    const [titleDialogNode, setTitleDialogNode] = useState(null);
    
    const dispatch = useDispatch();

    const CELL_PADDING = '0.8ex';
    const COLOR_MY_LOCK = 'green';
    const COLOR_OTHER_LOCK = '#cc0000';
    const COLOR_CHILD_LOCK = '#e0d910'; // '#e6df19';
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };


    useEffect( () => {
        netGet('/config/realm')
            .then(response => response.json())
            .then(rinfo => {
                if ( rinfo?.realm ) {
                    setOperator(rinfo.realm);
                }
            }).catch ( error => {
                console.log('Error fetching realm name: ' + error);
            });
    },[]);

    useEffect( () => {
        if ( open && instance ) {
            
            setErrorMessage('');
            loadInstanceConfiguration(instance);
            setSelectedNode(null);
            setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setOkEnabled(false);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
        } else {
            setEffNodes([]);
            setConfig(null);
            setErrorMessage('Please set required fields');
            setOkEnabled(false);
            setSelectedNode(null);
            setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'GEN', openWorkflowId: instance?.id}));
        // }

    },[open, instance]);

    const loadInstanceConfiguration = (inst) => {
        setEffNodes([]);
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.properties?.document) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config);
                    let nodes = config.properties?.eff?.target ? config.properties.eff.target : [];
                    if ( !Array.isArray(nodes) ) {
                        nodes = [];
                    }
                    const elist = [];
                    // flattenTree(elist, nodes);
                    setEffNodes(nodes);
                    // setEffList(elist);
                    setOkEnabled(false);
                    
                   
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = () => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        
        // console.log('OK enabled = ' + value);
        setOkEnabled(true);
    };


    /*
    React.useEffect(() => {
        

    }, []);
    */

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = { ...config };
            if ( !vv.name ) {
                vv.name = instance?.properties?.document;
            }
            if ( !vv.properties) {
                vv.properties = {};
            }
            if ( !vv.properties.eff) {
                vv.properties.eff = {};
            }
            vv.properties.eff.target = [...effNodes];            
            onSave(vv, action);
        }
    }

    const onNextClick = () => {
        onOKClick('NEXT');
    };

    const onPreviousClick = () => {
        const action = okEnabled ? 'PREV_OK' : 'PREV_CANCEL';
        onOKClick(action);
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const handleAddAction = () => {
        setEffDialogOpen(true);
        // clear selection so we don't get funnies
        setSelectedNodeKey({});
        setSelectedNode(null);
        setDeleteEnabled(false);
        setMoveupEnabled(false);
        setMovedownEnabled(false);
    };

    /*
    const handleSelectedNodeKey = (event) => {
        console.log('Selected Node key: ' + JSON.stringify(event?.value) );
        // console.log('Selected Node other: ' + JSON.stringify(other) );
        if (event.value) {
            setSelectedNodeKey(event.value);
            // console.log('Selected node keys: ' + JSON.stringify(Object.keys(event.value)));
            if (typeof event.value === 'string') {
                const sn = effList.find(n => n.key === event.value);
                setSelectedNode(sn);
                // setCurrentNode(sn);
                if (sn) {
                    setDeleteEnabled(true);
                } else {
                    setDeleteEnabled(false);
                }
                const si = effList.findIndex(n => n.key === event.value);
                setMoveupEnabled(si > 0);
                setMovedownEnabled(si >= 0 && si < effList.length - 1);
            } else {
                let sn = null;
                let skey = null;
                const size = Object.keys(event.value).length;
                for(let key in event.value) {
                    if ( typeof event.value[key] === 'boolean' && event.value[key] ) {
                        sn = effList.find(n => n.key === key);
                        // size++;
                        skey = key;
                        if ( sn ) {
                            break;
                        }
                    }
                }
                if ( sn ) {
                    setDeleteEnabled(true);
                    setSelectedNode(sn);
                } else {
                    setDeleteEnabled(false);
                    setSelectedNode(null);
                }
                if ( size === 1 ) {
                    // console.log('Finding key: ' + skey);
                    const si = effList.findIndex(n => n.key === skey);
                    if ( si >= 0 ) {
                        const sn = effList[si];
                        setMoveupEnabled(si > 0);
                        setMovedownEnabled(si < effList.length - 1);
                        setMoveoutEnabled(typeof sn?.data?.kparent === 'string' && !sn.data.kparent.length > 0);
                    }
                } else {
                    // console.log('MULTIPLE');
                    setMoveupEnabled(false);
                    setMovedownEnabled(false);
                    setMoveoutEnabled(false);
                    // setSelectedNodeKey({});
                }
            }
        } else {
            setSelectedNodeKey(null);
            // setCurrentNode(null);
            setSelectedNode(null);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
            setMoveoutEnabled(false);
        }
    };
    */

    const handleSelectedNode = (event) => {
        console.log('Selected Node: ' + JSON.stringify(event.node?.key) );
        setSelectedNode(event.node);
        /*
        const keys = {};
        if ( event.node?.key ) {
            keys[event.node.key] = true;
        }
        setSelectedNodeKey(keys);
        */
        // setCurrentNode(event.node);
    };

    const handleToggleNode = (event) => {
        setExpandedKeys(event.value);
    };

    const toggleNode = (node) => {
        let xkeys = expandedKeys ? { ...expandedKeys } : {};
        if (xkeys[node.key]) {
            delete xkeys[node.key];
        } else {
            xkeys[node.key] = true;
        }
        setExpandedKeys(xkeys);
    };

    const flattenTree = ( list, tree ) => {
        if (Array.isArray(tree) ) {
            tree.forEach( t => {
                list.push(t);
                if ( Array.isArray(t.children) ) {
                    flattenTree(list, t.children);
                }
            });
        }
    };


    const getSelectable = (node) => {
        if ( node ) {
            if ( typeof node.data.select === 'boolean' ) {
                return node.data.select;
            } 
        }
        return true;
    }

    const onSelectableChange = (node, event) => {
        console.log('Selectable: ' + node.key + ' ' + event.target.checked);
        if ( node ) {
            const ee = [...effNodes];
            //const elist = [];
            //flattenTree(elist, ee);
            const cn = ee.find( n => n.key === node.key);
            // console.log('Selected color node = ' + JSON.stringify(cn));
            if ( cn ) {
                cn.data.select = event.target.checked;
                // setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
            }
        }

    }

    const selectableTemplate = (node, options) => {
        return (
            <Checkbox checked={getSelectable(node)} onChange={(event) => onSelectableChange(node, event)} />
        );
    };

    
    const loadLabelMap = (model, labelmap) => {
        if (Array.isArray(model) && model.length > 0 ) {
            model.forEach(item => {
                labelmap[item.data.elabel] = item;
                loadLabelMap(item.children, labelmap);
            });
        }
    };

    const findNode = (root, node) => {
        if ( root.key === node.key ) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNode(c, node);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    };

    const findNodeByLabel = (root, label) => {
        if ( root.data.elabel === label) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNodeByLabel(c, label);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    }

   

    const handleEffSave = (nodes) => {
        setEffDialogOpen(false);
        const ee = [...effNodes];
        // simply append nodes, let admin organize as desired, including removing duplicates
        nodes.forEach ( n => ee.push(n));
        // const elist = [];
        // flattenTree(elist, ee);
        // setEffList(elist);
        setEffNodes(ee);
        setOkEnabled(true);
    };

    
    const deleteNode = (enodes, key) => {
        // const elist = [];
        // flattenTree(elist, enodes);
        const dn = enodes.find(n => n.key === key);
        if (dn) {
            const pn = dn.data?.pkey ? enodes.find(n => n.key === dn.data?.pkey) : null;
            if (pn) {
                // remove from internal node
                const i = Array.isArray(pn.children) ? pn.children.findIndex(n => n.key === dn.key) : -1;
                if (i >= 0) {
                    pn.children.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            pn.children.push(c);
                            c.data.pkey = pn.key;
                        });
                        pn.children.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }

                }
            } else {
                // remove from effNodes
                const i = enodes.findIndex(n => n.key === dn.key);
                if (i >= 0) {
                    enodes.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            enodes.push(c);
                            c.data.pkey = null;
                        });
                        enodes.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }
                }
            }
            // elist.splice(0, elist.length);
            //flattenTree(elist, enodes);
            // setEffNodes(enodes);
            // setEffList(elist);
        }
    };

    const handleDeleteAction = () => {
        if (selectedNodeKey) {
            const enodes = [...effNodes];
            if (typeof selectedNodeKey === 'string') {
                deleteNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key] ) {
                        deleteNode(enodes, key);
                    }
                }
            }
            // const elist = [];
            // flattenTree(elist, enodes);
            setEffNodes(enodes);
            // setEffList(elist);
            setOkEnabled(true);
        }
    };

    

    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { 
                    sx: {
                        minWidth: 900,
                        maxWidth: 1100,
                        maxHeight: 750,
                        minHeight: 700,
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>

                <Box sx={{display: 'flex', paddingTop: '2ex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="outlined" onClick={onPreviousClick} sx={{minWidth: '9.5em'}} startIcon={<ArrowBackIosIcon/>}>Previous</Button>
                    <Button variant="outlined" onClick={onNextClick} sx={{minWidth: '9.5em'}} disabled={!okEnabled} endIcon={<ArrowForwardIosIcon/>}>Next</Button>
                </Box>

                <Box sx={{ overflow: 'hidden', paddingTop: '2em', height: '460px' }}>
                    <TableContainer component={Paper} sx={{ height: '9em' }}>
                        <Table stickyHeader sx={{ minWidth: 350 }} aria-label="action table" size="small">
                            <TableHead>
                                <TableRow sx={{ paddingTop: 0, paddingBotton: 0 }}>
                                    <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', width: '8em', fontWeight: 'bold' }}>Effectivity</TableCell>
                                    <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold' }}>Format</TableCell>
                                    <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold' }}>Output For Each Tail</TableCell>
                                    <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold' }}>Margin Effectivity</TableCell>
                                    <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold' }}>Color Effectivity</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* actionData.map((row, index) => (
                                    <TableRow
                                        key={`${row.name}-${index}`}
                                        onClick={(event) => handleActionRowClicked(event, index)}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        selected={isActionRowSelected(index)}
                                    >
                                        <TableCell component="th" scope="row" sx={{ width: '8em', paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem' }}>
                                            {row.name}
                                        </TableCell>
                                        <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem' }}>{formatActionProperties(row.properties)}</TableCell>
                                    </TableRow>
                                )) */}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                
                <EffectivityChooserDialog open={effDialogOpen} onCancel={() => setEffDialogOpen(false)} onSave={handleEffSave} instance={instance} />
                {/* 
                <ColorPickerDialog open={colorDialogOpen} color={colorDialogValue} onCancel={() => setColorDialogOpen(false)} onSave={handleColorSave} disableAlpha={true} />
                <EditTitleDialog open={titleDialogOpen} value={titleDialogValue} onCancel={() => setTitleDialogOpen(false)} onSave={handleTitleDialogSave} />
                */}
            </DialogContent>
            <DialogActions sx={{padding: 3, paddingTop: 1, display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{ paddingTop: '1em', display: 'flex' }}>
                    <Tooltip title="Add Output">
                        <span>
                            <IconButton color="inherit" onClick={handleAddAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                                <AddIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Delete Output">
                        <span>
                            <IconButton disabled={!deleteEnabled} color="inherit" onClick={handleDeleteAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                                <DeleteIcon color="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    
                </Box>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );

}

function CreateProcessingConfigurationPanel(props) {
    const {
        title = 'Configure Processing Outputs',
        instance = null,
        open,
        onSave,
        onChange,
        onCancel,
        ...other
    } = props;

    const [effNodes, setEffNodes] = useState([]); // Effectivity Config entries
    // const [effList, setEffList] = useState([]); // same as effNodes but items are flatten into a list
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null);
    const [expandedKeys, setExpandedKeys] = useState({});
    const [selectedIndex, setSelectedIndex] = useState(-1);

    const [config, setConfig] = useState(null); // DLib config id (Long)
    const [operator, setOperator] = useState('');
    const [okEnabled, setOkEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [contextMenu, setContextMenu] = React.useState(null);
    const [menuIndex, setMenuIndex] = React.useState(1);

    const [effDialogOpen, setEffDialogOpen] = useState(false);

    const docOutput = useSelector((state) => state.documentConfig.output);

    const mid = React.useId();
    const menuId = `${mid}-menu`;
    
    const dispatch = useDispatch();

    const CELL_PADDING = '0.8ex';
    const COLOR_MY_LOCK = 'green';
    const COLOR_OTHER_LOCK = '#cc0000';
    const COLOR_CHILD_LOCK = '#e0d910'; // '#e6df19';
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };


    useEffect( () => {
        netGet('/config/realm')
            .then(response => response.json())
            .then(rinfo => {
                if ( rinfo?.realm ) {
                    setOperator(rinfo.realm);
                }
            }).catch ( error => {
                console.log('Error fetching realm name: ' + error);
            });
    },[]);

    useEffect( () => {
        if ( docOutput ) {
            setSelectedIndex(-1);
            setErrorMessage('');
            const sout = JSON.stringify(docOutput);
            setEffNodes(JSON.parse(sout));
            // setEffNodes([...docOutput]);
            // loadInstanceConfiguration(instance);
            setSelectedNode(null);
            //setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setOkEnabled(false);
            setDeleteEnabled(false);
            //setMoveupEnabled(false);
            //setMovedownEnabled(false);
        } else {
            setEffNodes([]);
            setSelectedIndex(-1);
            setConfig(null);
            setErrorMessage('Please set required fields');
            setOkEnabled(false);
            setSelectedNode(null);
            //setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setDeleteEnabled(false);
            //setMoveupEnabled(false);
            //setMovedownEnabled(false);
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'GEN', openWorkflowId: instance?.id}));
        // }

    },[docOutput]);

    const loadInstanceConfiguration = (inst) => {
        setEffNodes([]);
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.properties?.document) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config);
                    let nodes = config.properties?.eff?.target ? config.properties.eff.target : [];
                    if ( !Array.isArray(nodes) ) {
                        nodes = [];
                    }
                    const elist = [];
                    // flattenTree(elist, nodes);
                    setEffNodes(nodes);
                    // setEffList(elist);
                    setOkEnabled(false);
                    
                   
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = () => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        
        // console.log('OK enabled = ' + value);
        setOkEnabled(true);
    };


    /*
    React.useEffect(() => {
        

    }, []);
    */

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = { ...config };
            if ( !vv.name ) {
                vv.name = instance?.properties?.document;
            }
            if ( !vv.properties) {
                vv.properties = {};
            }
            if ( !vv.properties.eff) {
                vv.properties.eff = {};
            }
            vv.properties.eff.target = [...effNodes];            
            onSave(vv, action);
        }
    }

    /*
    const onNextClick = () => {
        onOKClick('NEXT');
    };

    const onPreviousClick = () => {
        const action = okEnabled ? 'PREV_OK' : 'PREV_CANCEL';
        onOKClick(action);
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };
    */
    
    const handleAddAction = () => {
        setEffDialogOpen(true);
        // clear selection so we don't get funnies
        setSelectedNodeKey({});
        setSelectedNode(null);
        setDeleteEnabled(false);
        // setMoveupEnabled(false);
        // setMovedownEnabled(false);
    };
    

    /*
    const handleSelectedNodeKey = (event) => {
        console.log('Selected Node key: ' + JSON.stringify(event?.value) );
        // console.log('Selected Node other: ' + JSON.stringify(other) );
        if (event.value) {
            setSelectedNodeKey(event.value);
            // console.log('Selected node keys: ' + JSON.stringify(Object.keys(event.value)));
            if (typeof event.value === 'string') {
                const sn = effList.find(n => n.key === event.value);
                setSelectedNode(sn);
                // setCurrentNode(sn);
                if (sn) {
                    setDeleteEnabled(true);
                } else {
                    setDeleteEnabled(false);
                }
                const si = effList.findIndex(n => n.key === event.value);
                setMoveupEnabled(si > 0);
                setMovedownEnabled(si >= 0 && si < effList.length - 1);
            } else {
                let sn = null;
                let skey = null;
                const size = Object.keys(event.value).length;
                for(let key in event.value) {
                    if ( typeof event.value[key] === 'boolean' && event.value[key] ) {
                        sn = effList.find(n => n.key === key);
                        // size++;
                        skey = key;
                        if ( sn ) {
                            break;
                        }
                    }
                }
                if ( sn ) {
                    setDeleteEnabled(true);
                    setSelectedNode(sn);
                } else {
                    setDeleteEnabled(false);
                    setSelectedNode(null);
                }
                if ( size === 1 ) {
                    // console.log('Finding key: ' + skey);
                    const si = effList.findIndex(n => n.key === skey);
                    if ( si >= 0 ) {
                        const sn = effList[si];
                        setMoveupEnabled(si > 0);
                        setMovedownEnabled(si < effList.length - 1);
                        setMoveoutEnabled(typeof sn?.data?.kparent === 'string' && !sn.data.kparent.length > 0);
                    }
                } else {
                    // console.log('MULTIPLE');
                    setMoveupEnabled(false);
                    setMovedownEnabled(false);
                    setMoveoutEnabled(false);
                    // setSelectedNodeKey({});
                }
            }
        } else {
            setSelectedNodeKey(null);
            // setCurrentNode(null);
            setSelectedNode(null);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
            setMoveoutEnabled(false);
        }
    };
    */

    const handleSelectedNode = (event) => {
        console.log('Selected Node: ' + JSON.stringify(event.node?.key) );
        setSelectedNode(event.node);
        /*
        const keys = {};
        if ( event.node?.key ) {
            keys[event.node.key] = true;
        }
        setSelectedNodeKey(keys);
        */
        // setCurrentNode(event.node);
    };

    const handleToggleNode = (event) => {
        setExpandedKeys(event.value);
    };

    const toggleNode = (node) => {
        let xkeys = expandedKeys ? { ...expandedKeys } : {};
        if (xkeys[node.key]) {
            delete xkeys[node.key];
        } else {
            xkeys[node.key] = true;
        }
        setExpandedKeys(xkeys);
    };

    const flattenTree = ( list, tree ) => {
        if (Array.isArray(tree) ) {
            tree.forEach( t => {
                list.push(t);
                if ( Array.isArray(t.children) ) {
                    flattenTree(list, t.children);
                }
            });
        }
    };


    const getSelectable = (node) => {
        if ( node ) {
            if ( typeof node.data.select === 'boolean' ) {
                return node.data.select;
            } 
        }
        return true;
    }

    const onSelectableChange = (node, event) => {
        console.log('Selectable: ' + node.key + ' ' + event.target.checked);
        if ( node ) {
            const ee = [...effNodes];
            //const elist = [];
            //flattenTree(elist, ee);
            const cn = ee.find( n => n.key === node.key);
            // console.log('Selected color node = ' + JSON.stringify(cn));
            if ( cn ) {
                cn.data.select = event.target.checked;
                // setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
            }
        }

    }

    const selectableTemplate = (node, options) => {
        return (
            <Checkbox checked={getSelectable(node)} onChange={(event) => onSelectableChange(node, event)} />
        );
    };

    
    const loadLabelMap = (model, labelmap) => {
        if (Array.isArray(model) && model.length > 0 ) {
            model.forEach(item => {
                labelmap[item.data.elabel] = item;
                loadLabelMap(item.children, labelmap);
            });
        }
    };

    const findNode = (root, node) => {
        if ( root.key === node.key ) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNode(c, node);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    };

    const findNodeByLabel = (root, label) => {
        if ( root.data.elabel === label) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNodeByLabel(c, label);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    }

   

    const handleEffSave = (nodes) => {
        setEffDialogOpen(false);
        const ee = [...effNodes];
        // simply append nodes, let admin organize as desired, including removing duplicates
        nodes.forEach ( n => ee.push(n));
        // const elist = [];
        // flattenTree(elist, ee);
        // setEffList(elist);
        setEffNodes(ee);
        // console.log('Nodes Saved: ' + JSON.stringify(ee));
        setOkEnabled(true);
        if ( typeof onChange === 'function') {
            onChange(ee);
        }
    };

    
    const deleteNode = (enodes, key) => {
        // const elist = [];
        // flattenTree(elist, enodes);
        const dn = enodes.find(n => n.key === key);
        if (dn) {
            const pn = dn.data?.pkey ? enodes.find(n => n.key === dn.data?.pkey) : null;
            if (pn) {
                // remove from internal node
                const i = Array.isArray(pn.children) ? pn.children.findIndex(n => n.key === dn.key) : -1;
                if (i >= 0) {
                    pn.children.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            pn.children.push(c);
                            c.data.pkey = pn.key;
                        });
                        pn.children.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }

                }
            } else {
                // remove from effNodes
                const i = enodes.findIndex(n => n.key === dn.key);
                if (i >= 0) {
                    enodes.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            enodes.push(c);
                            c.data.pkey = null;
                        });
                        enodes.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }
                }
            }
            // elist.splice(0, elist.length);
            //flattenTree(elist, enodes);
            setEffNodes(enodes);
            // setEffList(elist);
        }
    };

    const handleDeleteAction = () => {
        if (selectedIndex >= 0 && selectedIndex < effNodes.length) {
            const enodes = [...effNodes];
            /*
            if (typeof selectedNodeKey === 'string') {
                deleteNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key] ) {
                        deleteNode(enodes, key);
                    }
                }
            }
            */
            enodes.splice(selectedIndex,1);
            setSelectedIndex(-1);
            setDeleteEnabled(false);
            // const elist = [];
            // flattenTree(elist, enodes);
            setEffNodes(enodes);
            // setEffList(elist);
            setOkEnabled(true);
            if ( typeof onChange === 'function') {
                onChange(enodes);
            }
        }
    };

    const handleActionRowClicked = (event, index) => {
        setSelectedIndex(index);
        if ( index >= 0 ) {
            setDeleteEnabled(true);
        } else {
            setDeleteEnabled(false);
        }
    };

    const isActionRowSelected = (index) => {
        return index === selectedIndex;
    };

    const handleTailChange = (value, index) => {
        console.log('Tail changed: ' + value + ' : ' + index);
        if ( Array.isArray(effNodes) &&  index < effNodes.length ) {
            const en = [...effNodes];
            en[index] = {...effNodes[index]};
            en[index]['data'] = {...effNodes[index]['data']};
            en[index]['data']['tail'] = value;
            console.log('Tail change: ' + JSON.stringify(en[index]['data']));
            setEffNodes(en);
            if ( typeof onChange === 'function') {
                onChange(en);
            }
        }
    };

    const handleMarginChange = (value, index) => {
        console.log('Margin changed: ' + value + ' : ' + index);
        if ( Array.isArray(effNodes) &&  index < effNodes.length ) {
            const en = [...effNodes];
            en[index] = {...effNodes[index]};
            en[index]['data'] = {...effNodes[index]['data']};
            en[index]['data']['marginEff'] = value;
            
            console.log('Margin change: ' + JSON.stringify(en[index]['data']));
            setEffNodes(en);
            if ( typeof onChange === 'function') {
                onChange(en);
            }
        }
    };

    const handleColorChange = (value, index) => {
        console.log('Color changed: ' + value + ' : ' + index);
        if ( Array.isArray(effNodes) &&  index < effNodes.length ) {
            const en = [...effNodes];
            en[index] = {...effNodes[index]};
            en[index]['data'] = {...effNodes[index]['data']};
            en[index]['data']['colorEff'] = value;
            console.log('Color change: ' + JSON.stringify(en[index]['data']));
            setEffNodes(en);
            if ( typeof onChange === 'function') {
                onChange(en);
            }
        }
    };

    const handleContextMenu = (event, index) => {
        event.preventDefault();
        // setMenuIndex(index); // 0: HTML, 1: PDF
        setSelectedIndex(index);
        const item = effNodes[index];
        if ( item?.data?.format === 'HTML' ) {
            setMenuIndex(0);
        } else {
            setMenuIndex(1);
        }
        if ( index < effNodes.length ) {
            const item = effNodes[index];
            if ( item.data.format === 'HTML' ) {
                setMenuIndex(0);
            } else {
                setMenuIndex(1);
            }
        }
        
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                // Other native context menus might behave different.
                // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        );
    };

    const handleMenuClick = (value) => {
        
        if ( selectedIndex < effNodes.length ) {
            const en = [...effNodes];
            en[selectedIndex]['data']['format'] = value;
            setEffNodes(en);
        }
        handleMenuClose();
    };

    const handleMenuClose = () => {
        setContextMenu(null);
        setMenuIndex(-1);
    };
    

    return (
        
        <Box>
            <Box sx={{ overflow: 'hidden', paddingTop: '2em', height: '620px' }}>
                <TableContainer component={Paper} sx={{ height: '580px' }}>
                    <Table stickyHeader sx={{ minWidth: 350 }} aria-label="action table" size="small">
                        <TableHead>
                            <TableRow sx={{ paddingTop: 0, paddingBotton: 0 }}>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', width: '8em', fontWeight: 'bold' }}>Effectivity</TableCell>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>Format</TableCell>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>Output For Each Tail</TableCell>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>Margin Effectivity</TableCell>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>Color Effectivity</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {effNodes.map((row, index) => (
                                    <TableRow
                                        key={`${row.key}-${index}`}
                                        onClick={(event) => handleActionRowClicked(event, index)}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        selected={isActionRowSelected(index)}
                                    >
                                        <TableCell scope="row" sx={{ width: '8em', paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem' }}>
                                            {row.data?.item?.name}
                                        </TableCell>
                                        <TableCell sx={{textAlign: 'center', cursor: 'context-menu'}}
                                            onContextMenu={event => handleContextMenu(event, index)}
                                            >{row.data.format ? row.data.format : 'PDF'}</TableCell>
                                        <TableCell sx={{textAlign: 'center'}}><Checkbox checked={row.data?.tail} onChange={(event) => handleTailChange(event.target.checked, index)}/></TableCell>
                                        <TableCell sx={{textAlign: 'center'}}><Checkbox checked={row.data?.marginEff} onChange={(event) => handleMarginChange(event.target.checked, index)}/></TableCell>
                                        <TableCell sx={{textAlign: 'center'}}><Checkbox checked={row.data?.colorEff} onChange={(event) => handleColorChange(event.target.checked, index)}/></TableCell>
                                        {/* <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem' }}>{formatActionProperties(row.properties)}</TableCell> */}
                                    </TableRow>
                                )) 
                                }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box sx={{ paddingTop: '1em', display: 'flex' }}>
                <Tooltip title="Add Output">
                    <span>
                        <IconButton color="inherit" onClick={handleAddAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <AddIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete Output">
                    <span>
                        <IconButton disabled={!deleteEnabled} color="inherit" onClick={handleDeleteAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <DeleteIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>

            </Box>
            <Menu
                id={menuId}
                open={contextMenu !== null}
                onClose={handleMenuClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
            >
                <MenuItem onClick={() => handleMenuClick('HTML')} selected={menuIndex === 0}>
                    {menuIndex === 0 ?
                        <>
                            <ListItemIcon>
                                <Check />
                            </ListItemIcon><ListItemText>HTML</ListItemText> </> :
                        <ListItemText inset>HTML</ListItemText>
                    }
                </MenuItem>
                <MenuItem onClick={() => handleMenuClick('PDF')} selected={menuIndex === 1}>
                    {menuIndex === 1 ?
                        <>
                            <ListItemIcon>
                                <Check />
                            </ListItemIcon><ListItemText>PDF</ListItemText> </> :
                        <ListItemText inset>PDF</ListItemText>
                    }
                </MenuItem>
            </Menu>                    
            <EffectivityChooserDialog open={effDialogOpen} onCancel={() => setEffDialogOpen(false)} onSave={handleEffSave} instance={instance} />

        </Box>
    );

}

function EditProcessingConfigurationPanel(props) {
    const {
        title = 'Configure Processing Outputs',
        document,
        open,
        onSave,
        onChange,
        onCancel,
        readOnly=false,
        ...other
    } = props;

    const [effNodes, setEffNodes] = useState([]); // Effectivity Config entries
    // const [effList, setEffList] = useState([]); // same as effNodes but items are flatten into a list
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null);
    const [expandedKeys, setExpandedKeys] = useState({});
    const [selectedIndex, setSelectedIndex] = useState(-1);

    const [config, setConfig] = useState(null); // DLib config id (Long)
    const [operator, setOperator] = useState('');
    const [okEnabled, setOkEnabled] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [contextMenu, setContextMenu] = React.useState(null);
    const [menuIndex, setMenuIndex] = React.useState(1);

    const [effDialogOpen, setEffDialogOpen] = useState(false);

    // const docOutput = useSelector((state) => state.documentConfig.output);

    const mid = React.useId();
    const menuId = `${mid}-menu`;
    
    const dispatch = useDispatch();

    const CELL_PADDING = '0.8ex';
    const COLOR_MY_LOCK = 'green';
    const COLOR_OTHER_LOCK = '#cc0000';
    const COLOR_CHILD_LOCK = '#e0d910'; // '#e6df19';
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };


    useEffect( () => {
        netGet('/config/realm')
            .then(response => response.json())
            .then(rinfo => {
                if ( rinfo?.realm ) {
                    setOperator(rinfo.realm);
                }
            }).catch ( error => {
                console.log('Error fetching realm name: ' + error);
            });
    },[]);

    useEffect( () => {
        if ( document ) {
            setSelectedIndex(-1);
            setErrorMessage('');
            // const sout = JSON.stringify(docOutput);
            // setEffNodes(JSON.parse(sout));
            // setEffNodes([...docOutput]);
            loadInstanceConfiguration(document);
            setSelectedNode(null);
            //setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setOkEnabled(false);
            setDeleteEnabled(false);
            //setMoveupEnabled(false);
            //setMovedownEnabled(false);
        } else {
            setEffNodes([]);
            setSelectedIndex(-1);
            setConfig(null);
            setErrorMessage('Please set required fields');
            setOkEnabled(false);
            setSelectedNode(null);
            //setColorNode(null);
            setExpandedKeys({});
            setSelectedNodeKey({});
            setDeleteEnabled(false);
            //setMoveupEnabled(false);
            //setMovedownEnabled(false);
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'GEN', openWorkflowId: instance?.id}));
        // }

    },[document]);

    const loadInstanceConfiguration = (inst) => {
        setEffNodes([]);
        netGet('/api/dlib/config/get/byname/' + encodeURIComponent(inst.id) + '?categ=DOC')
            .then(resp => resp.json())
            .then(config => {
                if ( config ) {
                    setConfig(config);
                    let nodes = config.properties?.eff?.target ? config.properties.eff.target : [];
                    if ( !Array.isArray(nodes) ) {
                        nodes = [];
                    }
                    const elist = [];
                    // flattenTree(elist, nodes);
                    setEffNodes(nodes);
                    // setEffList(elist);
                    setOkEnabled(false);
                    
                   
                }
            }).catch(error => {
                console.log('Failed to retrieve DL config for document: ' + inst.properties?.document);
            });
    };

    const computeOkEnable = () => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        
        // console.log('OK enabled = ' + value);
        setOkEnabled(true);
    };


    /*
    React.useEffect(() => {
        

    }, []);
    */

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            const vv = { ...config };
            if ( !vv.name ) {
                vv.name = document?.title;
            }
            if ( !vv.properties) {
                vv.properties = {};
            }
            if ( !vv.properties.eff) {
                vv.properties.eff = {};
            }
            vv.properties.eff.target = [...effNodes];            
            onSave(vv, action);
        }
    }

    /*
    const onNextClick = () => {
        onOKClick('NEXT');
    };

    const onPreviousClick = () => {
        const action = okEnabled ? 'PREV_OK' : 'PREV_CANCEL';
        onOKClick(action);
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };
    */
    
    const handleAddAction = () => {
        setEffDialogOpen(true);
        // clear selection so we don't get funnies
        setSelectedNodeKey({});
        setSelectedNode(null);
        setDeleteEnabled(false);
        // setMoveupEnabled(false);
        // setMovedownEnabled(false);
    };
    

    /*
    const handleSelectedNodeKey = (event) => {
        console.log('Selected Node key: ' + JSON.stringify(event?.value) );
        // console.log('Selected Node other: ' + JSON.stringify(other) );
        if (event.value) {
            setSelectedNodeKey(event.value);
            // console.log('Selected node keys: ' + JSON.stringify(Object.keys(event.value)));
            if (typeof event.value === 'string') {
                const sn = effList.find(n => n.key === event.value);
                setSelectedNode(sn);
                // setCurrentNode(sn);
                if (sn) {
                    setDeleteEnabled(true);
                } else {
                    setDeleteEnabled(false);
                }
                const si = effList.findIndex(n => n.key === event.value);
                setMoveupEnabled(si > 0);
                setMovedownEnabled(si >= 0 && si < effList.length - 1);
            } else {
                let sn = null;
                let skey = null;
                const size = Object.keys(event.value).length;
                for(let key in event.value) {
                    if ( typeof event.value[key] === 'boolean' && event.value[key] ) {
                        sn = effList.find(n => n.key === key);
                        // size++;
                        skey = key;
                        if ( sn ) {
                            break;
                        }
                    }
                }
                if ( sn ) {
                    setDeleteEnabled(true);
                    setSelectedNode(sn);
                } else {
                    setDeleteEnabled(false);
                    setSelectedNode(null);
                }
                if ( size === 1 ) {
                    // console.log('Finding key: ' + skey);
                    const si = effList.findIndex(n => n.key === skey);
                    if ( si >= 0 ) {
                        const sn = effList[si];
                        setMoveupEnabled(si > 0);
                        setMovedownEnabled(si < effList.length - 1);
                        setMoveoutEnabled(typeof sn?.data?.kparent === 'string' && !sn.data.kparent.length > 0);
                    }
                } else {
                    // console.log('MULTIPLE');
                    setMoveupEnabled(false);
                    setMovedownEnabled(false);
                    setMoveoutEnabled(false);
                    // setSelectedNodeKey({});
                }
            }
        } else {
            setSelectedNodeKey(null);
            // setCurrentNode(null);
            setSelectedNode(null);
            setDeleteEnabled(false);
            setMoveupEnabled(false);
            setMovedownEnabled(false);
            setMoveoutEnabled(false);
        }
    };
    */

    const handleSelectedNode = (event) => {
        console.log('Selected Node: ' + JSON.stringify(event.node?.key) );
        setSelectedNode(event.node);
        /*
        const keys = {};
        if ( event.node?.key ) {
            keys[event.node.key] = true;
        }
        setSelectedNodeKey(keys);
        */
        // setCurrentNode(event.node);
    };

    const handleToggleNode = (event) => {
        setExpandedKeys(event.value);
    };

    const toggleNode = (node) => {
        let xkeys = expandedKeys ? { ...expandedKeys } : {};
        if (xkeys[node.key]) {
            delete xkeys[node.key];
        } else {
            xkeys[node.key] = true;
        }
        setExpandedKeys(xkeys);
    };

    const flattenTree = ( list, tree ) => {
        if (Array.isArray(tree) ) {
            tree.forEach( t => {
                list.push(t);
                if ( Array.isArray(t.children) ) {
                    flattenTree(list, t.children);
                }
            });
        }
    };


    const getSelectable = (node) => {
        if ( node ) {
            if ( typeof node.data.select === 'boolean' ) {
                return node.data.select;
            } 
        }
        return true;
    }

    const onSelectableChange = (node, event) => {
        console.log('Selectable: ' + node.key + ' ' + event.target.checked);
        if ( node ) {
            const ee = [...effNodes];
            //const elist = [];
            //flattenTree(elist, ee);
            const cn = ee.find( n => n.key === node.key);
            // console.log('Selected color node = ' + JSON.stringify(cn));
            if ( cn ) {
                cn.data.select = event.target.checked;
                // setEffList(elist);
                setEffNodes(ee);
                setOkEnabled(true);
            }
        }

    }

    const selectableTemplate = (node, options) => {
        return (
            <Checkbox checked={getSelectable(node)} onChange={(event) => onSelectableChange(node, event)} />
        );
    };

    
    const loadLabelMap = (model, labelmap) => {
        if (Array.isArray(model) && model.length > 0 ) {
            model.forEach(item => {
                labelmap[item.data.elabel] = item;
                loadLabelMap(item.children, labelmap);
            });
        }
    };

    const findNode = (root, node) => {
        if ( root.key === node.key ) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNode(c, node);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    };

    const findNodeByLabel = (root, label) => {
        if ( root.data.elabel === label) {
            return root;
        }
        if ( Array.isArray(root.children) ) {
            for(let i=0; i<root.children.length; i++) {
                const c = root.children[i];
                const tc = findNodeByLabel(c, label);
                if ( tc ) {
                    return tc;
                }
            }
        }
        return undefined;
    }

   

    const handleEffSave = (nodes) => {
        setEffDialogOpen(false);
        const ee = [...effNodes];
        // simply append nodes, let admin organize as desired, including removing duplicates
        nodes.forEach ( n => ee.push(n));
        // const elist = [];
        // flattenTree(elist, ee);
        // setEffList(elist);
        setEffNodes(ee);
        // console.log('Nodes Saved: ' + JSON.stringify(ee));
        setOkEnabled(true);
        if ( typeof onChange === 'function') {
            onChange(ee);
        }
    };

    
    const deleteNode = (enodes, key) => {
        // const elist = [];
        // flattenTree(elist, enodes);
        const dn = enodes.find(n => n.key === key);
        if (dn) {
            const pn = dn.data?.pkey ? enodes.find(n => n.key === dn.data?.pkey) : null;
            if (pn) {
                // remove from internal node
                const i = Array.isArray(pn.children) ? pn.children.findIndex(n => n.key === dn.key) : -1;
                if (i >= 0) {
                    pn.children.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            pn.children.push(c);
                            c.data.pkey = pn.key;
                        });
                        pn.children.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }

                }
            } else {
                // remove from effNodes
                const i = enodes.findIndex(n => n.key === dn.key);
                if (i >= 0) {
                    enodes.splice(i, 1);
                    if (Array.isArray(dn.children) && dn.children.length > 0) {
                        dn.children.forEach(c => {
                            enodes.push(c);
                            c.data.pkey = null;
                        });
                        enodes.sort((a, b) => a.data?.item?.seq - b.data?.item?.seq);
                    }
                }
            }
            // elist.splice(0, elist.length);
            //flattenTree(elist, enodes);
            setEffNodes(enodes);
            // setEffList(elist);
        }
    };

    const handleDeleteAction = () => {
        if (selectedIndex >= 0 && selectedIndex < effNodes.length) {
            const enodes = [...effNodes];
            /*
            if (typeof selectedNodeKey === 'string') {
                deleteNode(enodes, selectedNodeKey);
            } else {
                for (let key in selectedNodeKey) {
                    if (typeof selectedNodeKey[key] === 'boolean' && selectedNodeKey[key] ) {
                        deleteNode(enodes, key);
                    }
                }
            }
            */
            enodes.splice(selectedIndex,1);
            setSelectedIndex(-1);
            setDeleteEnabled(false);
            // const elist = [];
            // flattenTree(elist, enodes);
            setEffNodes(enodes);
            // setEffList(elist);
            setOkEnabled(true);
            if ( typeof onChange === 'function') {
                onChange(enodes);
            }
        }
    };

    const handleActionRowClicked = (event, index) => {
        setSelectedIndex(index);
        if ( index >= 0 ) {
            setDeleteEnabled(true);
        } else {
            setDeleteEnabled(false);
        }
    };

    const isActionRowSelected = (index) => {
        return index === selectedIndex;
    };

    const handleTailChange = (value, index) => {
        console.log('Tail changed: ' + value + ' : ' + index);
        if ( Array.isArray(effNodes) &&  index < effNodes.length ) {
            const en = [...effNodes];
            en[index] = {...effNodes[index]};
            en[index]['data'] = {...effNodes[index]['data']};
            en[index]['data']['tail'] = value;
            console.log('Tail change: ' + JSON.stringify(en[index]['data']));
            setEffNodes(en);
            if ( typeof onChange === 'function') {
                onChange(en);
            }
        }
    };

    const handleMarginChange = (value, index) => {
        console.log('Margin changed: ' + value + ' : ' + index);
        if ( Array.isArray(effNodes) &&  index < effNodes.length ) {
            const en = [...effNodes];
            en[index] = {...effNodes[index]};
            en[index]['data'] = {...effNodes[index]['data']};
            en[index]['data']['marginEff'] = value;
            
            console.log('Margin change: ' + JSON.stringify(en[index]['data']));
            setEffNodes(en);
            if ( typeof onChange === 'function') {
                onChange(en);
            }
        }
    };

    const handleColorChange = (value, index) => {
        console.log('Color changed: ' + value + ' : ' + index);
        if ( Array.isArray(effNodes) &&  index < effNodes.length ) {
            const en = [...effNodes];
            en[index] = {...effNodes[index]};
            en[index]['data'] = {...effNodes[index]['data']};
            en[index]['data']['colorEff'] = value;
            console.log('Color change: ' + JSON.stringify(en[index]['data']));
            setEffNodes(en);
            if ( typeof onChange === 'function') {
                onChange(en);
            }
        }
    };

    const handleContextMenu = (event, index) => {
        event.preventDefault();
        // setMenuIndex(index); // 0: HTML, 1: PDF
        setSelectedIndex(index);
        const item = effNodes[index];
        if ( item?.data?.format === 'HTML' ) {
            setMenuIndex(0);
        } else {
            setMenuIndex(1);
        }
        if ( index < effNodes.length ) {
            const item = effNodes[index];
            if ( item.data.format === 'HTML' ) {
                setMenuIndex(0);
            } else {
                setMenuIndex(1);
            }
        }
        
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                // Other native context menus might behave different.
                // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        );
    };

    const handleMenuClick = (value) => {
        
        if ( selectedIndex < effNodes.length ) {
            const en = [...effNodes];
            en[selectedIndex]['data']['format'] = value;
            setEffNodes(en);
        }
        handleMenuClose();
    };

    const handleMenuClose = () => {
        setContextMenu(null);
        setMenuIndex(-1);
    };
    

    return (
        
        <Box sx={{display: 'flex', flexDirection: 'column', pb: 1}}>
            <Box sx={{ overflow: 'hidden', paddingTop: '2em', flexGrow: '1' }}>
                <TableContainer component={Paper} sx={{ maxHeight: '580px' }}>
                    <Table stickyHeader sx={{ minWidth: 350 }} aria-label="action table" size="small">
                        <TableHead>
                            <TableRow sx={{ paddingTop: 0, paddingBotton: 0 }}>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', width: '8em', fontWeight: 'bold' }}>Effectivity</TableCell>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>Format</TableCell>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>Output For Each Tail</TableCell>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>Margin Effectivity</TableCell>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>Color Effectivity</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {effNodes.map((row, index) => (
                                    <TableRow
                                        key={`${row.key}-${index}`}
                                        onClick={(event) => handleActionRowClicked(event, index)}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        selected={isActionRowSelected(index)}
                                    >
                                        <TableCell scope="row" sx={{ width: '8em', paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem' }}>
                                            {row.data?.item?.name}
                                        </TableCell>
                                        <TableCell sx={{textAlign: 'center', cursor: 'context-menu'}}
                                            onContextMenu={event => handleContextMenu(event, index)}
                                            >{row.data.format ? row.data.format : 'PDF'}</TableCell>
                                        <TableCell sx={{textAlign: 'center'}}><Checkbox disabled={readOnly} checked={row.data?.tail} onChange={(event) => handleTailChange(event.target.checked, index)}/></TableCell>
                                        <TableCell sx={{textAlign: 'center'}}><Checkbox disabled={readOnly} checked={row.data?.marginEff} onChange={(event) => handleMarginChange(event.target.checked, index)}/></TableCell>
                                        <TableCell sx={{textAlign: 'center'}}><Checkbox disabled={readOnly} checked={row.data?.colorEff} onChange={(event) => handleColorChange(event.target.checked, index)}/></TableCell>
                                        {/* <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem' }}>{formatActionProperties(row.properties)}</TableCell> */}
                                    </TableRow>
                                )) 
                                }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box sx={{ paddingTop: '1em', display: 'flex' }}>
                <Tooltip title="Add Output">
                    <span>
                        <IconButton color="inherit" disabled={readOnly} onClick={handleAddAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <AddIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete Output">
                    <span>
                        <IconButton disabled={!deleteEnabled || readOnly} color="inherit" onClick={handleDeleteAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <DeleteIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>

            </Box>
            <Menu
                id={menuId}
                open={contextMenu !== null && !readOnly}
                onClose={handleMenuClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
            >
                <MenuItem onClick={() => handleMenuClick('HTML')} selected={menuIndex === 0}>
                    {menuIndex === 0 ?
                        <>
                            <ListItemIcon>
                                <Check />
                            </ListItemIcon><ListItemText>HTML</ListItemText> </> :
                        <ListItemText inset>HTML</ListItemText>
                    }
                </MenuItem>
                <MenuItem onClick={() => handleMenuClick('PDF')} selected={menuIndex === 1}>
                    {menuIndex === 1 ?
                        <>
                            <ListItemIcon>
                                <Check />
                            </ListItemIcon><ListItemText>PDF</ListItemText> </> :
                        <ListItemText inset>PDF</ListItemText>
                    }
                </MenuItem>
            </Menu>                    
            <EffectivityChooserDialog open={effDialogOpen} onCancel={() => setEffDialogOpen(false)} onSave={handleEffSave} instance={document} />

        </Box>
    );

}

function CreateDocumentRevisionRecordDialog(props) {
    const {
        title = 'Configure Revision Record',
        instance = null,
        open,
        onSave,
        onCancel,
        initial=true, // whether this is the initial create document dialog outside of workflow
        ...other
    } = props;

    const [recordsValue, setRecordsValue] = useState({});
    const [okEnabled, setOkEnabled] = useState(false);
    const [config, setConfig] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [docId, setDocId] = useState(null);
    const dispatch = useDispatch();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };

    /*
    useEffect( () => {
        
    }, []);
    */

    useEffect( () => {
        if ( open && instance ) {
            setDocId(instance.properties);
            // console.log('Setting doc = ' + instance.properties?.document);
            setErrorMessage('');
        } else {
            setOkEnabled(false);
            setErrorMessage('Please set required fields.');
        }
        // if ( open ) {
            // dispatch(setOpenNextStep({openNextStep: false, openStepAction: 'SCH', openWorkflowId: instance?.id}));
        // }
    },[open, instance]);

    

    const computeOkEnable = (name, label, style ) => {
        // check docid doesn't clash with other docs but exclude the current saved docid for this document
        let value = true;
        
        if ( value ) {
            setErrorMessage('');
        }
        //console.log('OK enabled = ' + value);
        setOkEnabled(value);
    };

    const onOKClick = (action) => {
        if ( typeof onSave === 'function' ) {
            
            onSave(recordsValue, action);
        }
    };

    const onNextClick = () => {
        onOKClick('NEXT');
    }

    const onPreviousClick = () => {
        const action = okEnabled ? 'PREV_OK' : 'PREV_CANCEL';
        onOKClick(action);
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const onRecordsChange = (records) => {
        setRecordsValue(records);
        setOkEnabled(true);
    };


    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { 
                    sx: {
                        minWidth: 800,
                        minHeight: 750,
                        maxHeight: 700
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent sx={{height: '100%'}}>
                <Box sx={{display: 'flex', paddingTop: '2ex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="outlined" onClick={onPreviousClick} sx={{minWidth: '9.5em'}} startIcon={<ArrowBackIosIcon/>}>Previous</Button>
                    <Button variant="outlined" onClick={onNextClick} sx={{minWidth: '9.5em'}} disabled={!okEnabled} endIcon={<ArrowForwardIosIcon/>}>Next</Button>
                </Box>
                <Box sx={{height: '520px'}}>
                    <RevisionRecordConfig doc={docId} onChange={onRecordsChange} open={open} sx={{padding: 1}} />
                </Box>
            </DialogContent>
            <DialogActions sx={{padding: 3, display: 'flex', justifyContent: 'space-between'}}>
                <Typography color="warning">{errorMessage}</Typography>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );

}




export { CreateDocumentGeneralDialog, CreateDocumentSchemaDialog, CreateDocumentEffectivityDialog, CreateDocumentRevisionRecordDialog, CreateProcessingConfigurationDialog,
    CreateDocumentGeneralPanel, CreateDocumentSchemaPanel, CreateProcessingConfigurationPanel, CreateDocumentEffectivityPanel,
    EditDocumentGeneralPanel, EditDocumentSchemaPanel, EditDocumentEffectivityPanel, EditProcessingConfigurationPanel,
 };